/**
 * German UI texts (formal "Sie"). de-CH is derived automatically (ß → ss),
 * de-AT uses this catalog unchanged. Tax terms come from the country profile.
 */
export const de = {
  "app.name": "Rhinvoice",
  "app.skipToContent": "Zum Inhalt springen",
  "app.loading": "Wird geladen …",
  "app.pageTitle": "{title} · Rhinvoice",

  "nav.main": "Hauptnavigation",
  "nav.dashboard": "Übersicht",
  "nav.documents": "Dokumente",
  "nav.invoices": "Rechnungen",
  "nav.quotes": "Angebote",
  "nav.customers": "Kunden",
  "nav.articles": "Artikel",
  "nav.settings": "Einstellungen",
  "nav.newInvoice": "Neue Rechnung",
  "nav.more": "Mehr",
  "nav.openMenu": "Menü öffnen",
  "nav.collapse": "Seitenleiste einklappen",
  "nav.expand": "Seitenleiste ausklappen",

  "topbar.search": "Suchen …",
  "topbar.help": "Hilfe und Tastaturkürzel",
  "topbar.account": "Konto",
  "topbar.logout": "Abmelden",

  "theme.label": "Farbschema",
  "theme.light": "Hell",
  "theme.dark": "Dunkel",
  "theme.system": "System",
  "language.label": "Sprache",
  "language.machineTranslated": "Maschinell übersetzt – Rückmeldungen sind willkommen",
  "demo.title": "Demo",
  "demo.loginHint":
    "Probieren Sie Rhinvoice mit Beispieldaten aus. Alle Besucher teilen sich diese Demo; sie wird alle {minutes} Minuten zurückgesetzt, E-Mails werden nicht versendet.",
  "demo.locked":
    "In der öffentlichen Demo nicht verfügbar: Hier sind alle Besucher mit demselben Zugang angemeldet, und es werden keine E-Mails versendet.",
  "demo.signIn": "Demo öffnen",
  "demo.otherCountries": "Auch als Demo:",
  "demo.banner":
    "Beispieldaten und Beispielkonten, bitte nichts überweisen · alle {minutes} Minuten zurückgesetzt, keine E-Mails",
  "demo.countryDemo": "Demo {country}",
  "about.title": "Über Rhinvoice",
  "about.version": "Version {version}",
  "about.description":
    "Open-Source-Rechnungsprogramm für die Schweiz, Liechtenstein, Deutschland und Österreich.",
  "about.license": "Lizenz: GNU Affero General Public License v3",
  "about.source": "Quellcode",
  "about.reportBug": "Problem melden",
  "support.title": "Problem melden",
  "support.description":
    "Rhinvoice verschickt nichts von selbst. Sie kopieren die Angaben und entscheiden, wohin sie gehen.",
  "support.copyStep":
    "1. Protokoll kopieren. Es kann Namen von Kunden enthalten: Schauen Sie es vor dem Senden kurz an.",
  "support.copy": "Protokoll kopieren",
  "support.copied": "Protokoll kopiert",
  "support.copyFailed":
    "Kopieren hat nicht funktioniert. Markieren Sie den Text unten und kopieren Sie ihn selbst.",
  "support.serverStep":
    "1. Das Protokoll liegt auf dem Server. Führen Sie dort diesen Befehl aus und kopieren Sie die Ausgabe:",
  "support.sendStep": "2. Auf GitHub melden oder per Mail an {email} schicken.",
  "support.github": "Auf GitHub melden",
  "about.changelog": "Neuerungen",
  "about.noAdvice": "Keine Steuerberatung, Steuersätze ohne Gewähr.",
  "about.machineTranslated":
    "Diese Übersetzung wurde maschinell erstellt. Hinweise auf Fehler sind willkommen:",
  "about.reportTranslation": "Übersetzungsfehler melden",

  "updates.title": "Aktualisierung",
  "updates.newVersion": "Neue Version {version}",
  "updates.notes": "Was ist neu?",
  "updates.install": "Jetzt aktualisieren",
  "updates.installHint": "Dauert etwa eine halbe Minute. Ihre Daten werden vorher gesichert.",
  "updates.installing": "Wird heruntergeladen …",
  "updates.restarting": "Rhinvoice startet neu …",
  "updates.commandEnv": "In der Datei .env setzen:",
  "updates.commandEnvIfPinned": "Nur wenn .env eine feste Version hat, dort setzen:",
  "updates.commandOnly": "Auf dem Server ausführen:",
  "updates.commandRun": "Dann auf dem Server ausführen:",
  "updates.setupTitle": "{version} braucht ein neues Setup",
  "updates.setupHint": "Einmal installieren, Ihre Daten bleiben erhalten.",
  "updates.setupDownload": "Setup herunterladen",
  "updates.failedTitle": "Das Update auf {version} hat nicht funktioniert",
  "updates.failedHint": "Rhinvoice {current} läuft wieder, Ihre Daten sind unverändert.",
  "updates.upToDate": "Rhinvoice ist auf dem neuesten Stand.",
  "updates.notChecked": "Ob es eine neue Version gibt, wurde noch nicht geprüft.",
  "updates.check": "Nach Updates suchen",
  "updates.checking": "Wird geprüft …",
  "updates.setupDownloading": "Wird heruntergeladen … {received} von {total} MB",
  "updates.setupReady": "Heruntergeladen und geprüft.",
  "updates.setupInstall": "Installieren",
  "updates.setupFailed": "Der Download hat nicht geklappt.",
  "updates.setupRetry": "Erneut versuchen",
  "updates.setupByHand": "Setup selbst herunterladen",
  "updates.closeTitle": "Rhinvoice für das Update schließen?",
  "updates.closeSetup":
    "Rhinvoice schließt sich, installiert {version} und startet danach von selbst wieder. Das dauert etwa eine Minute, Ihre Daten bleiben erhalten.",
  "updates.closeRestart":
    "Rhinvoice startet für {version} neu. Das dauert etwa eine halbe Minute, Ihre Daten werden vorher gesichert.",
  "updates.closeSaveFirst": "Speichern Sie vorher alles, woran Sie gerade arbeiten.",
  "updates.closeUnsaved":
    "Es gibt noch ungespeicherte Änderungen. Wählen Sie „Später“, speichern Sie und starten Sie das Update dann noch einmal.",
  "updates.closeConfirm": "Schließen und aktualisieren",
  "updates.closeAnyway": "Trotzdem schließen",
  "updates.later": "Später",
  "updates.closing": "Rhinvoice wird für das Update geschlossen …",
  "about.madeBy": "made by {maker}",
  "about.legalNotice": "Impressum",
  "about.privacy": "Datenschutz",
  "about.openSource": "Open Source",

  "palette.title": "Befehlspalette",
  "palette.placeholder": "Befehl oder Suchbegriff eingeben …",
  "palette.empty": "Keine Treffer.",
  "palette.actions": "Aktionen",
  "palette.navigation": "Navigation",
  "palette.toggleTheme": "Farbschema wechseln",
  "palette.shortcuts": "Tastaturkürzel anzeigen",

  "shortcuts.title": "Tastaturkürzel",
  "shortcuts.description":
    "Einzeltasten-Kürzel sind nur aktiv, wenn kein Eingabefeld fokussiert ist.",
  "shortcuts.groupGeneral": "Allgemein",
  "shortcuts.groupNavigation": "Navigation",
  "shortcuts.palette": "Befehlspalette öffnen",
  "shortcuts.search": "Suche fokussieren",
  "shortcuts.newInvoice": "Neue Rechnung",
  "shortcuts.save": "Speichern",
  "shortcuts.help": "Diese Übersicht",
  "shortcuts.close": "Dialog schließen",
  "shortcuts.goDashboard": "Gehe zur Übersicht",
  "shortcuts.goInvoices": "Gehe zu Rechnungen",
  "shortcuts.goCustomers": "Gehe zu Kunden",
  "shortcuts.goArticles": "Gehe zu Artikeln",
  "shortcuts.goSettings": "Gehe zu Einstellungen",
  "shortcuts.then": "dann",

  "auth.loginTitle": "Anmelden",
  "auth.loginDescription": "Melden Sie sich mit Ihrer E-Mail-Adresse an.",
  "auth.email": "E-Mail-Adresse",
  "auth.password": "Passwort",
  "auth.totpCode": "Bestätigungscode",
  "auth.totpHint": "Sechsstelliger Code aus Ihrer Authenticator-App.",
  "auth.submit": "Anmelden",
  "auth.submitting": "Wird angemeldet …",
  "auth.forgotPassword": "Passwort vergessen?",
  "auth.reset.title": "Passwort vergessen",
  "auth.reset.description":
    "Sie vergeben ein neues Passwort. Danach sind alle Anmeldungen mit dem alten beendet.",
  "auth.reset.administrator":
    "Ein neues Passwort setzt, wer den Server betreut. Bei einer Installation mit Docker im Ordner von Rhinvoice:",
  "auth.reset.whichAddress": "Welche E-Mail-Adresse? Dieser Befehl zeigt alle Konten:",
  "auth.reset.file":
    "Rhinvoice legt einen einmaligen Code in seinen Datenordner auf diesem Computer und öffnet die Datei. Darin stehen auch die E-Mail-Adressen der Konten.",
  "auth.reset.request": "Code anfordern",
  "auth.reset.again": "Neuen Code anfordern",
  "auth.reset.opened": "Die Datei mit dem Code ist geöffnet. Sie liegt hier:",
  "auth.reset.code": "Code",
  "auth.reset.newPassword": "Neues Passwort",
  "auth.reset.save": "Passwort speichern",
  "auth.reset.done": "Das Passwort ist geändert. Melden Sie sich mit dem neuen Passwort an.",
  "auth.reset.toLogin": "Zur Anmeldung",
  "auth.reset.back": "Zurück zur Anmeldung",
  "auth.setupTitle": "Rhinvoice einrichten",
  "auth.setupDescription":
    "Legen Sie das erste Benutzerkonto an. Es erhält Zugriff auf alle Daten dieser Installation.",
  "auth.displayName": "Ihr Name",
  "auth.newPassword": "Passwort",
  "auth.passwordHint":
    "Mindestens 12 Zeichen. Ein Satz aus mehreren Wörtern ist sicher und gut merkbar.",
  "auth.setupSubmit": "Konto anlegen",
  "auth.loggedOut": "Sie wurden abgemeldet.",
  "auth.sessionExpired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "auth.demoReset":
    "Die Demo wurde zurückgesetzt, wie alle {minutes} Minuten. Dabei werden alle abgemeldet: Bitte melden Sie sich erneut an.",

  "validation.required": "Bitte ausfüllen.",
  "validation.email": "Bitte geben Sie eine gültige E-Mail-Adresse ein, z. B. name@firma.ch.",
  "validation.passwordLength": "Das Passwort muss mindestens 12 Zeichen lang sein.",
  "validation.totp": "Der Code besteht aus 6 Ziffern.",
  "validation.summary": {
    one: "1 Angabe muss korrigiert werden",
    other: "{count} Angaben müssen korrigiert werden",
  },

  "error.demo_locked": "In der öffentlichen Demo ist das nicht möglich.",
  "error.update_running": "Das Update wird bereits installiert.",
  "error.update_check_failed":
    "Die Angaben zu neuen Versionen konnten nicht abgerufen werden. Ist der Computer mit dem Internet verbunden?",
  "error.update_check_off": "Die Suche nach Updates ist in dieser Installation ausgeschaltet.",
  "error.no_update": "Es gibt hier kein Update zu installieren.",
  "error.generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  "error.network": "Keine Verbindung zum Server. Bitte prüfen Sie Ihre Verbindung.",
  "error.authentication_failed": "E-Mail-Adresse oder Passwort ist falsch.",
  "error.session_expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "error.not_logged_in": "Sie sind nicht angemeldet.",
  "error.reset_code_invalid":
    "Die E-Mail-Adresse oder der Code stimmt nicht, oder der Code ist abgelaufen. Nach fünf Fehlversuchen braucht es einen neuen Code.",
  "error.reset_by_administrator":
    "Hier setzt ein Administrator das Passwort auf dem Server zurück.",
  "error.rate_limited": "Zu viele Versuche von dieser Adresse. Bitte warten Sie eine Minute.",
  "error.account_locked": "Zu viele Fehlversuche. Das Konto ist für 15 Minuten gesperrt.",
  "error.totp_required": "Bitte geben Sie den Bestätigungscode ein.",
  "error.retry": "Erneut versuchen",
  "error.mail_not_configured":
    "Der E-Mail-Versand ist noch nicht eingerichtet (Einstellungen → E-Mail).",
  "error.mail_draft": "Entwürfe werden nicht versendet. Bitte stellen Sie das Dokument zuerst aus.",
  "error.mail_auth_failed": "Der Mailserver hat Benutzername oder Passwort abgelehnt.",
  "error.mail_recipient_refused":
    "Der Mailserver hat einen Empfänger abgelehnt. Bitte prüfen Sie die Adresse.",
  "error.mail_sender_refused":
    "Der Mailserver nimmt die Absenderadresse nicht an. Meist muss sie zum Konto beim Anbieter gehören.",
  "error.mail_tls_failed":
    "Die verschlüsselte Verbindung zum Mailserver ist fehlgeschlagen. Bitte prüfen Sie Port und Verschlüsselung.",
  "error.mail_timeout": "Der Mailserver hat nicht rechtzeitig geantwortet.",
  "error.mail_connection_failed":
    "Keine Verbindung zum Mailserver. Bitte prüfen Sie Server und Port.",
  "error.mail_failed": "Der Mailserver hat die E-Mail nicht angenommen.",
  "error.recipient_missing": "Bitte mindestens eine E-Mail-Adresse angeben.",
  "error.invalid_recipient": "Eine Empfängeradresse ist ungültig.",
  "error.mail_partly_refused":
    "Der Mailserver hat einen Teil der Empfänger abgelehnt; die übrigen haben die E-Mail erhalten (im Verlauf vermerkt).",
  "error.mail_too_large": "Die E-Mail ist größer, als der Mailserver annimmt.",
  "error.mail_utf8_unsupported":
    "Der Mailserver nimmt keine Adressen mit Umlauten oder Akzenten an.",
  "error.mail_login_needs_tls":
    "Eine Anmeldung braucht eine verschlüsselte Verbindung (STARTTLS oder SSL/TLS).",
  "error.mail_password_required":
    "Für einen anderen Server, Port oder Benutzer geben Sie das Passwort bitte nochmals ein.",
  "error.reminder_not_open":
    "Die Rechnung ist nicht mehr offen; ihre Mahnungen werden nicht mehr versendet.",
  "error.refusedRecipients": "Abgelehnt: {refused}.",
  "error.serverSaid": "Antwort des Servers: «{reply}»",
  "error.not_found": "Nicht gefunden. Möglicherweise wurde es inzwischen gelöscht.",
  "error.invalid_state":
    "Diese Aktion ist im aktuellen Status nicht möglich. Bitte laden Sie die Seite neu.",
  "error.bank_account_missing":
    "Für diese Währung ist kein Bankkonto erfasst. Bitte legen Sie es unter Einstellungen → Bankkonten an.",
  "error.bank_account_unknown":
    "Dieses Bankkonto gibt es nicht mehr. Bitte wählen Sie ein anderes.",
  "error.bank_account_currency": "Das Bankkonto ist in einer anderen Währung als das Dokument.",
  "error.holder_address_missing": "Ein Konto eines Dritten braucht die Adresse des Kontoinhabers.",
  "error.no_positions": "Das Dokument braucht mindestens eine Position mit Betrag.",
  "error.non_positive_total":
    "Das Total einer Rechnung muss größer als null sein. Gutschriften entstehen durch Stornieren.",
  "error.due_before_issue": "Das Fälligkeitsdatum liegt vor dem Datum.",
  "error.reverse_charge_needs_vat_number":
    "Für Reverse Charge braucht der Kunde eine UID / USt-IdNr. Bitte im Kunden ergänzen.",
  "error.company_vat_number_missing":
    "Auf der Rechnung muss Ihre MWST-Nummer bzw. UID stehen. Bitte unter Einstellungen → Firma ergänzen oder dort «Nicht MWST-pflichtig / Kleinunternehmer» wählen.",
  "error.company_tax_id_missing":
    "Auf der Rechnung muss Ihre Steuernummer oder USt-IdNr. stehen. Bitte unter Einstellungen → Firma ergänzen.",
  "error.company_vat_id_missing":
    "Für eine innergemeinschaftliche Lieferung muss Ihre USt-IdNr. bzw. UID auf der Rechnung stehen. Bitte unter Einstellungen → Firma ergänzen.",
  "error.customer_vat_id_missing":
    "Für eine innergemeinschaftliche Lieferung muss die USt-IdNr. bzw. UID des Kunden auf der Rechnung stehen. Bitte im Kunden ergänzen.",
  "error.goods_only_treatment":
    "Innergemeinschaftliche Lieferung und Ausfuhrlieferung gelten nur für Waren. Wählen Sie für das Dokument «Reverse Charge» bzw. «Export».",
  "error.customer_vat_number_required":
    "Bei Rechnungen über 10.000 EUR an Firmen in Österreich muss die UID des Kunden stehen. Bitte im Kunden ergänzen.",
  "error.issue_date_in_future": "Das Datum darf nicht in der Zukunft liegen.",
  "error.issue_date_before_last":
    "Das Datum liegt vor dem zuletzt ausgestellten Dokument. Nummern und Daten müssen aufsteigen.",
  "error.payment_exceeds_open_amount": "Der Betrag ist höher als der offene Betrag.",
  "error.payment_date_in_future": "Das Zahlungsdatum darf nicht in der Zukunft liegen.",
  "error.write_off_date_in_future": "Das Datum der Abschreibung darf nicht in der Zukunft liegen.",
  "error.payment_dated_before_write_off":
    "Die Zahlung ist vor der Abschreibung datiert. Nehmen Sie stattdessen die Abschreibung zurück.",
  "error.written_off":
    "Die Rechnung wurde abgeschrieben. Nehmen Sie zuerst die Abschreibung zurück.",
  "error.clock_went_back":
    "Die Uhr des Servers geht nach. Bitte versuchen Sie es in einem Moment noch einmal.",
  "error.write_off_before_invoice":
    "Das Datum der Abschreibung darf nicht vor dem Rechnungsdatum liegen.",
  "error.payment_before_write_off":
    "Diese Zahlung ging vor der Abschreibung ein. Nehmen Sie zuerst die Abschreibung zurück.",
  "error.unknown_placeholder":
    "Unbekannter Platzhalter. Möglich sind {nummer}, {datum}, {faellig}, {kunde}, {betrag}, {waehrung}, {firma}, {kontoinhaber} und {kontoinhaber_adresse}.",
  "error.already_converted": "Aus diesem Angebot wurde bereits eine Rechnung erstellt.",
  "error.pageDescription":
    "Diese Seite konnte nicht angezeigt werden. Ihre gespeicherten Daten sind nicht betroffen.",

  "dashboard.title": "Übersicht",
  "dashboard.welcome": "Willkommen, {name}",
  "dashboard.emptyTitle": "Noch keine Rechnungen",
  "dashboard.emptyDescription":
    "Sobald Sie Rechnungen ausstellen, sehen Sie hier offene, überfällige und bezahlte Beträge.",

  "settings.title": "Einstellungen",
  "settings.account": "Konto",
  "settings.security": "Sicherheit",
  "settings.interaction": "Bedienung",
  "settings.singleKeyShortcuts": "Einzeltasten-Kürzel",
  "settings.singleKeyShortcutsHint":
    "Kürzel wie N (neue Rechnung) oder G dann C (Kunden). Deaktivieren Sie sie, wenn Sie Spracheingabe oder Hilfstechnologien nutzen. Die Befehlspalette ({mod} K) bleibt verfügbar.",
  "settings.changePassword": "Passwort ändern",
  "settings.currentPassword": "Aktuelles Passwort",
  "settings.newPassword": "Neues Passwort",
  "settings.passwordChanged": "Passwort geändert. Andere Sitzungen wurden abgemeldet.",
  "settings.totpTitle": "Zwei-Faktor-Authentifizierung",
  "settings.totpEnabled": "Aktiviert",
  "settings.totpDisabled": "Nicht aktiviert",
  "settings.totpDescription":
    "Schützt Ihr Konto zusätzlich mit einem Code aus einer Authenticator-App.",
  "settings.totpEnable": "Einrichten",
  "settings.totpDisable": "Deaktivieren",
  "settings.totpScan":
    "Fügen Sie diesen Schlüssel in Ihrer Authenticator-App hinzu und geben Sie dann den angezeigten Code ein.",
  "settings.totpSecret": "Schlüssel",
  "settings.totpConfirm": "Bestätigen",
  "settings.totpActivated": "Zwei-Faktor-Authentifizierung ist aktiviert.",
  "settings.totpDeactivated": "Zwei-Faktor-Authentifizierung ist deaktiviert.",
  "settings.totpDisableConfirm":
    "Bitte bestätigen Sie mit Ihrem Passwort und einem aktuellen Code.",

  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.optional": "(optional)",
  "common.copy": "Kopieren",
  "common.copied": "Kopiert",

  "common.new": "Neu",
  "common.edit": "Bearbeiten",
  "common.archive": "Archivieren",
  "common.restore": "Wiederherstellen",
  "common.archived": "Archiviert",
  "common.delete": "Löschen",
  "common.saved": "Gespeichert",
  "common.saving": "Wird gespeichert …",
  "common.back": "Zurück",
  "common.previous": "Vorherige Seite",
  "common.next": "Nächste Seite",
  "common.pageInfo": "{from}–{to} von {total}",
  "common.showArchived": "Archivierte anzeigen",
  "common.undo": "Rückgängig",
  "common.opensInNewTab": " (öffnet in einem neuen Tab)",
  "common.loadError": "Die Daten konnten nicht geladen werden.",
  "common.none": "—",
  "common.default": "Standard",
  "common.notSet": "Nicht gesetzt",
  "common.useDefault": "Standard verwenden",
  "common.saveShortcut": "Speichern ({mod} ↵)",
  "common.unsavedChanges": "Ungespeicherte Änderungen",
  "common.results": { zero: "Keine Treffer", one: "1 Treffer", other: "{count} Treffer" },
  "address.legend": "Adresse",
  "address.street": "Straße",
  "address.houseNumber": "Nr.",
  "address.supplement": "Adresszusatz",
  "address.supplementHint": "z. B. c/o, Postfach oder Abteilung",
  "address.postalCode": "PLZ",
  "address.city": "Ort",
  "address.country": "Land",
  "validation.maxLength": "Höchstens {max} Zeichen.",
  "validation.number": "Bitte geben Sie eine Zahl ein, z. B. {example}.",
  "validation.range": "Bitte eine Zahl von {min} bis {max} eingeben.",
  "validation.decimals": "Höchstens {max} Nachkommastellen.",
  "validation.percent": "Bitte einen Wert zwischen 0 und 100 eingeben.",
  "validation.days": "Bitte eine ganze Zahl von 0 bis 365 eingeben.",
  "validation.positiveInteger": "Bitte eine positive ganze Zahl eingeben.",
  "validation.iban.format":
    "Eine IBAN beginnt mit dem Ländercode und zwei Prüfziffern, z. B. CH93 0076 …",
  "validation.iban.country": "IBANs aus diesem Land werden nicht unterstützt.",
  "validation.iban.length": "Eine IBAN aus {country} hat {length} Zeichen – bitte prüfen.",
  "validation.iban.checksum": "Die Prüfziffern stimmen nicht – bitte auf Tippfehler prüfen.",
  "validation.iban.isQr":
    "Das ist eine QR-IBAN. Bitte im Feld QR-IBAN erfassen und hier die normale IBAN.",
  "validation.iban.notQr": "Eine QR-IBAN hat an Stelle 5–9 eine Zahl zwischen 30000 und 31999.",
  "validation.bic": "Ein BIC hat 8 oder 11 Zeichen, z. B. UBSWCHZH80A.",
  "validation.vat.swiss-format": "Eine UID hat die Form CHE-123.456.789.",
  "validation.vat.swiss-check-digit": "Die Prüfziffer der UID stimmt nicht – bitte prüfen.",
  "validation.vat.german-format": "Eine deutsche USt-IdNr. hat die Form DE123456789.",
  "validation.vat.austrian-format": "Eine österreichische UID hat die Form ATU12345678.",
  "validation.numberTaken": "Diese Nummer ist bereits vergeben.",
  "validation.server": "Bitte prüfen Sie diese Angabe ({message}).",
  "customers.title": "Kunden",
  "customers.new": "Neuer Kunde",
  "customers.edit": "Kunde bearbeiten",
  "customers.emptyTitle": "Noch keine Kunden",
  "customers.emptyDescription":
    "Legen Sie Ihren ersten Kunden an. Adresse und Konditionen werden später in Rechnungen übernommen.",
  "customers.noResults": "Keine Kunden für diese Suche.",
  "customers.resetSearch": "Suche zurücksetzen",
  "customers.searchLabel": "Kunden durchsuchen",
  "customers.searchPlaceholder": "Name, Nummer, Ort, E-Mail …",
  "customers.number": "Nr.",
  "customers.numberAndSince": "Kundennummer {number} · Kunde seit {since}",
  "customers.numberLabel": "Kundennummer",
  "customers.numberHint": "Leer lassen für die nächste freie Nummer.",
  "customers.name": "Name",
  "customers.city": "Ort",
  "customers.email": "E-Mail",
  "customers.group": "Gruppe",
  "customers.kind": "Art",
  "customers.kindCompany": "Firma",
  "customers.kindPerson": "Privatperson",
  "customers.sectionBasics": "Stammdaten",
  "customers.sectionContact": "Kontakt",
  "customers.sectionBilling": "Rechnungsstellung",
  "customers.sectionDelivery": "Lieferadresse",
  "customers.companyName": "Firmenname",
  "customers.salutation": "Anrede",
  "customers.salutationHint": "z. B. Herr, Frau oder leer",
  "customers.firstName": "Vorname",
  "customers.lastName": "Nachname",
  "customers.contactPerson": "Kontaktperson",
  "customers.contactPersonHint": "Erscheint als «z. Hd.» in der Adresse.",
  "customers.phone": "Telefon",
  "customers.vatNumber": "UID / USt-IdNr.",
  "customers.vatNumberHint": "Pflicht für Reverse Charge bei Firmenkunden in der EU.",
  "customers.buyerReference": "Leitweg-ID oder feste Käuferreferenz",
  "customers.buyerReferenceHint":
    "Für die XRechnung. Behörden: ihre Leitweg-ID. Firmen: nur eintragen, wenn sie immer dieselbe Referenz wünschen. Wechselt die Referenz pro Auftrag (z. B. Bestellnummer), lassen Sie dieses Feld leer und tragen sie in der Rechnung unter «Weitere Angaben → Referenz» ein.",
  "customers.defaultCurrency": "Standardwährung",
  "customers.defaultLanguage": "Dokumentsprache",
  "customers.taxExempt": "Steuerbefreit",
  "customers.taxExemptHint":
    "Nur für Kunden, die von der Steuer befreit sind, z. B. Botschaften oder internationale Organisationen. Nicht für Firmen im Ausland: Eine Firma in der EU mit UID (z. B. ATU12345678) erhält automatisch Reverse Charge, eine Firma außerhalb der EU automatisch eine Rechnung ohne MWST/USt (Export).",
  "customers.taxExemptReverseCharge":
    "Diese Firma hat eine UID in der EU: Ohne «Steuerbefreit» erhält sie automatisch Reverse Charge (Steuerschuldnerschaft des Leistungsempfängers). Mit «Steuerbefreit» steht stattdessen «Von der Mehrwertsteuer befreite Leistung» auf der Rechnung.",
  "customers.defaultDiscount": "Standard-Rabatt in %",
  "customers.paymentTerms": "Zahlungsfrist in Tagen",
  "customers.paymentTermsHint": "Leer lassen für die Zahlungsfrist der Firma.",
  "customers.hasDelivery": "Abweichende Lieferadresse",
  "customers.note": "Interne Notiz",
  "customers.noteHint": "Erscheint nicht auf Dokumenten.",
  "customers.created": "Kunde «{name}» angelegt.",
  "customers.sheetHint":
    "Die Rechnung bleibt dahinter offen. Nach dem Speichern geht es dort weiter.",
  "customers.createAndChoose": "Anlegen und wählen",
  "customers.archivedToast": "«{name}» archiviert.",
  "customers.restoredToast": "«{name}» wiederhergestellt.",
  "customers.archivedNotice":
    "Dieser Kunde ist archiviert und wird in Auswahllisten nicht angezeigt.",
  "customers.documentsTitle": "Dokumente",
  "customers.documentsEmpty": "Für diesen Kunden gibt es noch keine Dokumente.",
  "articles.title": "Artikel",
  "articles.new": "Neuer Artikel",
  "articles.edit": "Artikel bearbeiten",
  "articles.emptyTitle": "Noch keine Artikel",
  "articles.emptyDescription":
    "Erfassen Sie Produkte und Dienstleistungen mit Preis und Einheit, um sie in Rechnungen schnell einzufügen.",
  "articles.noResults": "Keine Artikel für diese Suche.",
  "articles.searchLabel": "Artikel durchsuchen",
  "articles.searchPlaceholder": "Name, Nummer, Beschreibung …",
  "articles.number": "Nr.",
  "articles.numberLabel": "Artikelnummer",
  "articles.name": "Bezeichnung",
  "articles.description": "Beschreibung",
  "articles.descriptionHint": "Erscheint unter der Bezeichnung auf dem Dokument.",
  "articles.group": "Gruppe",
  "articles.unit": "Einheit",
  "articles.taxCategory": "Steuersatz",
  "articles.supply": "Ware oder Dienstleistung",
  "articles.supplyHint":
    "Waren gehen steuerlich anders über die Grenze als Dienstleistungen (Ausfuhr, innergemeinschaftliche Lieferung).",
  "articles.price": "Preis",
  "articles.prices": "Preise (netto)",
  "articles.pricesHint": "Leer lassen, wenn der Artikel in dieser Währung nicht angeboten wird.",
  "articles.priceIn": "Preis in {currency}",
  "articles.created": "Artikel «{name}» angelegt.",
  "articles.archivedToast": "«{name}» archiviert.",
  "articles.restoredToast": "«{name}» wiederhergestellt.",
  "articles.archivedNotice":
    "Dieser Artikel ist archiviert und wird in Auswahllisten nicht angezeigt.",
  "tax.standard": "Normalsatz",
  "tax.reduced": "Reduzierter Satz",
  "tax.special": "Sondersatz",
  "tax.zero": "0 % (steuerbar)",
  "tax.exempt": "Von der Steuer ausgenommen",
  "supply.service": "Dienstleistung",
  "supply.goods": "Ware",
  "settings.tabMail": "E-Mail",
  "settings.tabCompany": "Firma",
  "settings.tabBankAccounts": "Bankkonten",
  "settings.tabNumbering": "Nummernkreise",
  "settings.tabTexts": "Texte",
  "texts.intro":
    "Textbausteine füllen neue Dokumente automatisch. Bausteine mit «Standard» werden eingesetzt, alle anderen können Sie im Editor auswählen.",
  "texts.documentType": "Dokumentart",
  "texts.kind.intro": "Einleitung",
  "texts.kind.payment": "Zahlungsbedingungen",
  "texts.kind.closing": "Schlusstext",
  "texts.kindHint.intro": "Steht vor den Positionen, z. B. ein Dank für den Auftrag.",
  "texts.kindHint.payment":
    "Steht nach den Summen. Mehrere Standard-Bausteine werden untereinander gesetzt.",
  "texts.kindHint.closing": "Steht am Ende des Dokuments, z. B. ein Gruss.",
  "texts.add": "Hinzufügen",
  "texts.addTitle": "Neuer Textbaustein",
  "texts.editTitle": "Textbaustein bearbeiten",
  "texts.empty": "Noch keine Textbausteine.",
  "texts.default": "Standard",
  "texts.moveUp": "«{name}» nach oben",
  "texts.moveDown": "«{name}» nach unten",
  "texts.edit": "«{name}» bearbeiten",
  "texts.delete": "«{name}» löschen",
  "texts.deleteTitle": "Textbaustein löschen?",
  "texts.deleteDescription":
    "«{name}» wird gelöscht. Dokumente, die den Text schon enthalten, bleiben unverändert.",
  "texts.deleted": "Textbaustein gelöscht",
  "texts.name": "Name",
  "texts.nameHint": "Kurz, so erscheint er im Editor, z. B. «Zahlbar prompt».",
  "texts.text": "Text",
  "texts.placeholders": "Platzhalter einfügen",
  "texts.insertPlaceholder": "Platzhalter für {placeholder} einfügen",
  "texts.placeholder.nummer": "Nummer",
  "texts.placeholder.datum": "Datum",
  "texts.placeholder.faellig": "Fälligkeit oder Gültigkeit",
  "texts.placeholder.kunde": "Kunde",
  "texts.placeholder.betrag": "Betrag",
  "texts.placeholder.waehrung": "Währung",
  "texts.placeholder.firma": "Ihre Firma",
  "texts.placeholder.kontoinhaber": "Kontoinhaber",
  "texts.placeholder.kontoinhaber_adresse": "Adresse des Kontoinhabers",
  "texts.useAsDefault": "In neue Dokumente einsetzen (Standard)",
  "texts.notices": "Gesetzliche Hinweise",
  "texts.noticesHint":
    "Erscheinen automatisch je nach Steuerfall. Beim Ausstellen wird der Wortlaut mit dem Dokument gespeichert. Keine Steuerberatung: bitte prüfen lassen.",
  "texts.noticeBuiltIn": "Vorgeschlagener Wortlaut für Ihr Land.",
  "texts.noticeCustomized": "Eigener Wortlaut.",
  "texts.restoreNotice": "Vorschlag wiederherstellen",
  "settings.tabSecurity": "Sicherheit",
  "settings.tabInteraction": "Bedienung",
  "company.title": "Firma",
  "company.description": "Diese Angaben erscheinen als Absender auf allen Dokumenten.",
  "company.setupHint": "Bitte erfassen Sie zuerst Ihre Firmendaten.",
  "company.name": "Firmenname",
  "company.sectionContact": "Kontakt",
  "company.sectionTax": "Steuern und Register",
  "company.sectionDefaults": "Voreinstellungen",
  "company.sectionAppearance": "Erscheinungsbild",
  "company.email": "E-Mail",
  "company.phone": "Telefon",
  "company.website": "Website",
  "company.vatNumber": "UID / MWST-Nr. / USt-IdNr.",
  "company.vatNumberHint": "z. B. CHE-123.456.789 MWST oder DE123456789",
  "company.taxNumber": "Steuernummer",
  "company.taxNumberHint": "Deutsche Steuernummer, falls keine USt-IdNr. vorhanden ist.",
  "company.taxDialogTitle": "Steuerangaben der Firma",
  "company.taxDialogHint":
    "Diese Angaben stehen auf jeder Rechnung und gelten ab sofort für die ganze Firma.",
  "company.taxDialogOtherErrors":
    "Andere Firmenangaben sind unvollständig. Bitte unter Einstellungen → Firma prüfen.",
  "company.commercialRegister": "Handelsregister",
  "company.commercialRegisterHint": "z. B. Handelsregister des Kantons Zürich, CHE-123.456.789",
  "company.smallBusiness": "Nicht MWST-pflichtig / Kleinunternehmer",
  "company.smallBusinessHint":
    "Rechnungen enthalten dann keine Steuer, aber den gesetzlich verlangten Hinweis.",
  "company.cashRounding": "Rappenrundung",
  "company.cashRoundingHint": "CHF-Beträge auf 0.05 runden.",
  "company.defaultCurrency": "Standardwährung",
  "company.defaultLanguage": "Dokumentsprache",
  "company.paymentTerms": "Zahlungsfrist in Tagen",
  "company.accentHue": "Akzentfarbe",
  "company.accentHueHint":
    "Farbton der Oberfläche (0–359). Alle Farbtöne sind auf Lesbarkeit geprüft.",
  "company.saved": "Firmendaten gespeichert.",
  "company.logo": "Logo",
  "company.logoHint": "PNG, JPEG oder WebP, höchstens 1 MB. Erscheint oben auf Dokumenten.",
  "company.logoUpload": "Logo hochladen",
  "company.logoReplace": "Logo ersetzen",
  "company.logoRemove": "Logo entfernen",
  "company.logoAlt": "Aktuelles Firmenlogo",
  "company.logoUploaded": "Logo gespeichert.",
  "company.logoRemoved": "Logo entfernt.",
  "company.logoTooLarge": "Das Logo darf höchstens 1 MB groß sein.",
  "language.de": "Deutsch",
  "language.en": "Englisch",
  "language.fr": "Französisch",
  "language.it": "Italienisch",
  "bank.title": "Bankkonten",
  "bank.description":
    "Konten für Zahlungsangaben und QR-Codes. Pro Währung ist ein Konto das Standardkonto; im Dokument können Sie ein anderes wählen.",
  "bank.add": "Konto hinzufügen",
  "bank.edit": "Konto bearbeiten",
  "bank.emptyTitle": "Noch kein Bankkonto",
  "bank.emptyDescription": "Erfassen Sie mindestens ein Konto pro Rechnungswährung.",
  "bank.bankName": "Bank",
  "bank.holder": "Kontoinhaber",
  "bank.iban": "IBAN",
  "bank.qrIban": "QR-IBAN",
  "bank.qrIbanHint": "Nur für QR-Rechnungen mit QR-Referenz (Schweiz und Liechtenstein).",
  "bank.bic": "BIC / SWIFT",
  "bank.bicEpcHint":
    "Nötig für den EPC-QR-Code auf Euro-Rechnungen an Kunden in der EU: Ohne BIC entfällt er.",
  "bank.currency": "Währung",
  "bank.isDefault": "Standardkonto für diese Währung",
  "bank.thirdParty": "Konto gehört einem Dritten (z. B. Finanzdienstleister)",
  "bank.thirdPartyHint":
    "Dokumente, die auf dieses Konto bezahlt werden, nennen den Kontoinhaber als Zahlungsempfänger. Seine Adresse steht im QR-Zahlteil.",
  "bank.thirdPartyBadge": "Drittkonto",
  "bank.holderAddress": "Adresse des Kontoinhabers",
  "bank.saved": "Bankkonto gespeichert.",
  "bank.deleteTitle": "Bankkonto löschen?",
  "bank.deleteDescription":
    "Bereits ausgestellte Dokumente behalten ihre Kontoangaben. Entwürfe und neue Dokumente nehmen das Standardkonto ihrer Währung.",
  "bank.deleted": "Bankkonto gelöscht.",
  "numbering.title": "Nummernkreise",
  "numbering.description":
    "Rechnungsnummern werden erst beim Ausstellen vergeben – lückenlos und eindeutig.",
  "numbering.kind.invoice": "Rechnungen",
  "numbering.kind.quote": "Angebote",
  "numbering.kind.cancellation": "Stornorechnungen",
  "numbering.kind.customer": "Kunden",
  "numbering.kind.article": "Artikel",
  "numbering.pattern": "Muster",
  "numbering.patternHint":
    "{YYYY} Jahr, {YY} Jahr zweistellig, {MM} Monat, {NNNN} Zähler (Anzahl N = Mindeststellen).",
  "numbering.nextValue": "Nächster Zähler",
  "numbering.nextValueHint": "Zum nahtlosen Anschluss an ein bisheriges Programm.",
  "numbering.startValue": "Startwert nach Jahreswechsel",
  "numbering.yearlyReset": "Jährlich zurücksetzen",
  "numbering.preview": "Nächste Nummer",
  "numbering.saved": "Nummernkreis gespeichert.",
  "numbering.problem.length": "Das Muster muss 1 bis 40 Zeichen lang sein.",
  "numbering.problem.placeholder":
    "Unbekannter Platzhalter. Erlaubt sind {YYYY}, {YY}, {MM} und {N…}.",
  "numbering.problem.counter": "Das Muster braucht genau einen Zähler wie {NNNN}.",
  "numbering.problem.characters":
    "Erlaubt sind Buchstaben, Ziffern und - _ / . sowie die Platzhalter.",
  "numbering.problem.year":
    "Bei jährlichem Zurücksetzen braucht das Muster {YYYY} oder {YY}, sonst wiederholen sich Nummern.",
  "shortcuts.newQuote": "Neues Angebot",
  "shortcuts.newCustomer": "Neuer Kunde",
  "shortcuts.newArticle": "Neuer Artikel",
  "shortcuts.or": "oder",
  "shortcuts.undo": "Letzte Aktion rückgängig machen (solange die Meldung sichtbar ist)",
  "shortcuts.payment": "Zahlung erfassen (im Dokument)",
  "shortcuts.moveLineUp": "Position nach oben (im Editor)",
  "shortcuts.moveLineDown": "Position nach unten (im Editor)",
  "shortcuts.goQuotes": "Gehe zu Angeboten",

  "dashboard.asTable": "Als Tabelle",
  "dashboard.currency": "Währung",
  "dashboard.revenueYear": "Umsatz {year}",
  "dashboard.vsLastYear": "zum Vorjahreszeitraum",
  "dashboard.noComparison": "kein Vorjahr",
  "dashboard.showInvoices": "Rechnungen ansehen",
  "dashboard.showOpen": "Offene Rechnungen",
  "dashboard.showDunning": "Zum Mahnwesen",
  "dashboard.showQuotes": "Offene Angebote ansehen",
  "dashboard.daysToPay": {
    zero: "Kunden zahlen am selben Tag",
    one: "Ø bezahlt nach 1 Tag",
    other: "Ø bezahlt nach {count} Tagen",
  },
  "dashboard.oldestOverdue": {
    zero: "heute fällig",
    one: "älteste seit 1 Tag",
    other: "älteste seit {count} Tagen",
  },
  "dashboard.openQuotes": "Offene Angebote",
  "dashboard.quoteCount": { zero: "Keine Angebote", one: "1 Angebot", other: "{count} Angebote" },
  "dashboard.acceptance": "Annahmequote {rate} in diesem Jahr",
  "dashboard.noDecisions": "Noch keine Angebote entschieden",
  "dashboard.aging": "Offen nach Fälligkeit",
  "dashboard.nothingOpen": "Keine offenen Rechnungen.",
  "dashboard.age.not_due": "Noch nicht fällig",
  "dashboard.age.late_30": "1–30 Tage überfällig",
  "dashboard.age.late_60": "31–60 Tage überfällig",
  "dashboard.age.late_more": "Über 60 Tage überfällig",
  "dashboard.overdueList": "Am längsten überfällig",
  "dashboard.noOverdue": "Keine überfälligen Rechnungen.",
  "dashboard.daysLate": {
    zero: "heute fällig",
    one: "1 Tag überfällig",
    other: "{count} Tage überfällig",
  },
  "dashboard.remind": "Zum Mahnwesen",
  "dashboard.topCustomers": "Top-Kunden {year}",
  "dashboard.topCustomersHint": "Nettoumsatz, abzüglich Stornos.",
  "dashboard.noCustomerRevenue": "In diesem Jahr noch kein Umsatz.",
  "dashboard.expected": "Erwartete Zahlungen",
  "dashboard.expectedHint":
    "Offene Rechnungen nach Woche der Fälligkeit; diese Woche mit allem Überfälligen.",
  "dashboard.week": "Woche",
  "dashboard.weekLabel": "KW {week}",
  "dashboard.amount": "Betrag",
  "dashboard.figuresIn": "Kennzahlen in {currency}",
  "dashboard.open": "Offen",
  "dashboard.openCount": {
    zero: "Keine offenen Rechnungen",
    one: "1 offene Rechnung",
    other: "{count} offene Rechnungen",
  },
  "dashboard.overdue": "Überfällig",
  "dashboard.overdueCount": {
    zero: "Nichts überfällig",
    one: "1 überfällige Rechnung",
    other: "{count} überfällige Rechnungen",
  },
  "dashboard.paid": "Bezahlt",
  "dashboard.paidHint": "Summe aller Zahlungseingänge",
  "dashboard.revenue": "Umsatz pro Monat",
  "dashboard.revenueHint": "Nettoumsatz in {currency}, abzüglich Stornos.",
  "dashboard.revenueIn": "Umsatz in {currency}",
  "dashboard.noRevenue": "In den letzten 12 Monaten wurden keine Rechnungen ausgestellt.",
  "dashboard.month": "Monat",
  "dashboard.netRevenue": "Umsatz netto",
  "dashboard.activity": "Letzte Aktivitäten",
  "dashboard.noActivity": "Noch keine Aktivitäten.",

  "documentType.invoice": "Rechnung",
  "documentType.quote": "Angebot",
  "documentType.cancellation": "Stornorechnung",

  "status.draft": "Entwurf",
  "status.sent": "Versendet",
  "status.accepted": "Angenommen",
  "status.declined": "Abgelehnt",
  "status.expired": "Abgelaufen",
  "status.issued": "Ausgestellt",
  "status.partially_paid": "Teilweise bezahlt",
  "status.overdue": "Überfällig",
  "status.overdueDays": {
    zero: "Überfällig",
    one: "Überfällig · 1 Tag",
    other: "Überfällig · {count} Tage",
  },
  "status.paid": "Bezahlt",
  "status.cancelled": "Storniert",
  "status.written_off": "Abgeschrieben",

  "event.emailed": "Per E-Mail versendet",
  "event.reminder_emailed": "Mahnung per E-Mail versendet",
  "event.created": "Erstellt",
  "event.created_from": "Erstellt aus",
  "event.issued": "Ausgestellt",
  "event.sent": "Versendet",
  "event.accepted": "Angenommen",
  "event.declined": "Abgelehnt",
  "event.converted": "In Rechnung umgewandelt",
  "event.payment_added": "Zahlung erfasst",
  "event.payment_removed": "Zahlung entfernt",
  "event.cancelled": "Storniert",
  "event.tax_overridden": "Steuerfall manuell gewählt",
  "event.reminded": "Mahnung geschrieben",
  "event.imported": "Aus früherem Programm übernommen",
  "event.file_added": "Datei hinzugefügt",
  "event.written_off": "Abgeschrieben",
  "event.write_off_removed": "Abschreibung zurückgenommen",

  "treatment.domestic": "Inland (steuerpflichtig)",
  "treatment.reverse_charge": "Reverse Charge",
  "treatment.export": "Export (steuerfrei)",
  "treatment.small_business": "Kleinunternehmer (ohne Steuer)",
  "treatment.exempt": "Von der Steuer befreit",
  "treatment.intra_community": "Innergemeinschaftliche Lieferung (steuerfrei)",
  "treatment.goods_export": "Ausfuhrlieferung (steuerfrei)",

  "documents.newInvoice": "Neue Rechnung",
  "documents.newQuote": "Neues Angebot",
  "documents.draftTitle": "{kind} (Entwurf)",
  "documents.numberedTitle": "{kind} {number}",
  "documents.searchLabel": "Dokumente durchsuchen",
  "documents.searchPlaceholder": "Nummer, Kunde, Betreff, Position …",
  "documents.views": "Ansicht",
  "documents.view.all": "Alle",
  "documents.view.draft": "Entwürfe",
  "documents.view.open": "Offen",
  "documents.view.overdue": "Überfällig",
  "documents.view.paid": "Bezahlt",
  "documents.view.cancelled": "Storniert",
  "documents.view.written_off": "Abgeschrieben",
  "documents.view.sent": "Versendet",
  "documents.view.accepted": "Angenommen",
  "documents.view.declined": "Abgelehnt",
  "documents.view.expired": "Abgelaufen",
  "documents.noResults": "Keine Dokumente für diesen Filter.",
  "documents.resetFilter": "Filter zurücksetzen",
  "documents.emptyInvoices": "Noch keine Rechnungen",
  "documents.emptyInvoicesDescription":
    "Erstellen Sie Ihre erste Rechnung. Die Nummer wird erst beim Ausstellen vergeben.",
  "documents.emptyQuotes": "Noch keine Angebote",
  "documents.emptyQuotesDescription":
    "Erstellen Sie ein Angebot und wandeln Sie es nach der Zusage mit einem Klick in eine Rechnung um.",
  "documents.number": "Nummer",
  "documents.status": "Status",
  "documents.amount": "Betrag",
  "documents.openShort": "offen {amount}",
  "documents.applyLine": "Übernehmen",
  "documents.customerNumber": "Kunden-Nr. {number}",
  "documents.customerSearch": "Kunde suchen",
  "documents.changeCustomer": "Ändern",
  "documents.discardLine": "Verwerfen",
  "documents.saveAsArticle": "Als Artikel speichern",
  "documents.articleSaved": "Artikel {number} «{name}» gespeichert.",
  "documents.dueInDays": "{days} Tage",
  "documents.dueNow": "Sofort",
  "documents.editLine": "Position {number} bearbeiten: {description}",
  "documents.editPane": "Bearbeiten",
  "documents.insertTemplate": "Textbaustein einsetzen …",
  "documents.linePriceIn": "Preis {currency}",
  "documents.manageTemplates": "Textbausteine verwalten",
  "documents.netTotal": "Netto {amount}",
  "documents.noLines":
    "Noch keine Positionen. Fügen Sie eine hinzu; beim Tippen werden Artikel vorgeschlagen.",
  "documents.noticeAuto": "Automatischer Hinweis:",
  "documents.paneSwitch": "Ansicht",
  "documents.paymentTemplates": "Zahlungsbedingungen aus Textbausteinen",
  "documents.paymentText": "Zahlungsbedingungen",
  "documents.payWithin": "Zahlungsfrist",
  "documents.placeholdersHint":
    "Platzhalter für Nummer, Fälligkeit, Kunde und Betrag werden beim Drucken ersetzt.",
  "documents.previewHint":
    "Die Vorschau zeigt das Dokument wie gedruckt. Ein Klick auf eine Position öffnet sie in der Liste.",
  "documents.previewPane": "Vorschau",
  "documents.cannotMarkPaid":
    "{number} kann nicht als bezahlt markiert werden (inzwischen bezahlt, storniert oder ein Entwurf). Es wurde nichts geändert.",
  "documents.popupBlocked":
    "Der Browser hat das neue Fenster blockiert. Bitte erlauben Sie Pop-ups für Rhinvoice oder nutzen Sie «Herunterladen».",
  "error.unavailable":
    "Der PDF-Dienst ist gerade nicht erreichbar. Bitte versuchen Sie es später erneut oder wenden Sie sich an die Person, die Rhinvoice betreibt.",
  "error.cannot_mark_paid":
    "Eine der ausgewählten Rechnungen kann nicht als bezahlt markiert werden (inzwischen bezahlt oder storniert). Es wurde nichts geändert.",
  "documents.autosaveFailed":
    "Automatisches Speichern fehlgeschlagen. Bitte speichern Sie von Hand.",
  "documents.pdf": "PDF",
  "documents.download": "Herunterladen",
  "documents.print": "Drucken",
  "documents.share": "Teilen",
  "documents.viewMode": "Darstellung",
  "documents.viewDocument": "Dokument",
  "documents.viewDetails": "Details",
  "documents.imported": "Übernommen",
  "documents.importedHint":
    "Aus einem früheren Programm übernommen. Das PDF ist die Rechnung; Positionen gibt es keine.",
  "documents.originalPdf": "Original-PDF",
  "documents.noPdf": "Noch kein PDF",
  "documents.noPdfHint":
    "Zu dieser Rechnung wurde beim Übernehmen kein PDF gefunden. Füge es hinzu, damit sie vollständig ist. Danach lässt es sich nicht mehr ersetzen.",
  "documents.addPdf": "PDF hinzufügen",
  "documents.attachmentsTitle": "Anhänge",
  "documents.attachmentsHint": "Mahnungen, Korrekturen und Kopien aus dem früheren Programm.",
  "documents.attachmentsEmpty": "Keine Anhänge.",
  "documents.addPdfTitle": "PDF hinzufügen?",
  "documents.addAttachmentTitle": "Datei anhängen?",
  "documents.addFileConfirm":
    "«{name}» wird dauerhaft bei dieser Rechnung aufbewahrt. Danach lässt sie sich weder ersetzen noch entfernen.",
  "documents.addAttachment": "Datei anhängen",
  "documents.fileAdded": "Datei hinzugefügt.",
  "documents.pdfAdded": "PDF hinzugefügt.",
  "documents.addFileHint":
    "Nur PDF, höchstens 20 MB. Hinzugefügte Dateien lassen sich nicht mehr entfernen.",
  "documents.paidOnUnknown":
    "Zahlungsdatum aus dem früheren Programm nicht bekannt; als Fälligkeit übernommen.",
  "documents.pdfLoading": "PDF wird geladen …",
  "documents.previewEmpty":
    "Die Vorschau erscheint, sobald ein Kunde und eine Position erfasst sind.",
  "documents.previewTitle": "Vorschau: {title}",
  "documents.reverseChargeHint":
    "Reverse Charge: keine {tax}. Der Hinweis und die UID des Kunden kommen automatisch auf das Dokument.",
  "documents.sectionMore": "Weitere Angaben",
  "documents.sectionMoreHint": "Betreff, Referenz, Leistungszeitraum, Währung, Rabatt",
  "documents.sectionTexts": "Texte",
  "documents.sectionTextsHint": "Einleitung, Zahlungsbedingungen, Schluss",
  "documents.filters": "Filter",
  "documents.year": "Jahr",
  "documents.allYears": "Alle Jahre",
  "documents.customerFilter": "Kunde",
  "documents.allCustomers": "Alle Kunden",
  "documents.removeCustomerFilter": "Kundenfilter entfernen",
  "documents.selectDocument": "{number} auswählen",
  "documents.selectAllPayable": "Alle offenen Rechnungen dieser Seite auswählen",
  "documents.markPaidShort": "Bezahlt",
  "documents.markPaidRow": "{number} als bezahlt markieren (heute, voller Betrag)",
  "documents.selection": "Auswahl",
  "documents.selectedCount": { one: "1 ausgewählt", other: "{count} ausgewählt" },
  "documents.markSelectedPaid": "Als bezahlt markieren",
  "documents.clearSelection": "Auswahl aufheben",
  "documents.markedPaidNumber": "{number} als bezahlt markiert",
  "documents.markedPaidMany": "{count} Rechnungen als bezahlt markiert",
  "documents.paymentsUndone": "Zahlungen entfernt",
  "documents.sums": "Summen",
  "documents.sumCountInvoices": {
    one: "1 Rechnung in {currency}",
    other: "{count} Rechnungen in {currency}",
  },
  "documents.sumCountQuotes": {
    one: "1 Angebot in {currency}",
    other: "{count} Angebote in {currency}",
  },
  "documents.sumTotal": "Total {amount}",
  "documents.sumOpen": "davon offen {amount}",
  "documents.companyMissingTitle": "Firmendaten fehlen",
  "documents.companyMissing":
    "Bitte erfassen Sie zuerst Ihre Firmendaten. Sie erscheinen als Absender auf jedem Dokument.",
  "documents.facts": "Eckdaten",

  "documents.sectionRecipient": "Empfänger und Betreff",
  "documents.customer": "Kunde",
  "documents.customerPlaceholder": "Name, Nummer oder Ort eingeben …",
  "documents.customerRequired": "Bitte wählen Sie einen Kunden.",
  "documents.noCustomerFound": "Kein Kunde gefunden.",
  "documents.createCustomerNamed": "«{name}» als neuen Kunden anlegen",
  "documents.noCustomersTitle": "Noch keine Kunden.",
  "documents.noCustomersHint":
    "Eine Rechnung braucht einen Empfänger. Legen Sie ihn hier an, die Rechnung bleibt offen.",
  "documents.createCustomer": "Kunden anlegen",
  "documents.importCustomers": "Kunden importieren",
  "documents.blockersTitle": "Vor dem Ausstellen fehlt noch:",
  "documents.blockersHint": "Speichern geht schon, nur das Ausstellen wartet darauf.",
  "blocker.bank_account_missing": "ein Bankkonto in {currency} für die Zahlungsangaben",
  "blocker.reverse_charge_needs_vat_number": "die UID bzw. USt-IdNr. des Kunden für Reverse Charge",
  "blocker.company_vat_number_missing":
    "Ihre MWST-Nummer bzw. UID, oder die Angabe «nicht MWST-pflichtig»",
  "blocker.company_tax_id_missing": "Ihre Steuernummer oder USt-IdNr.",
  "blocker.customer_vat_number_required": "die UID des Kunden (Rechnungen über 10.000 EUR)",
  "blocker.company_vat_id_missing":
    "Ihre USt-IdNr. bzw. UID für die innergemeinschaftliche Lieferung",
  "blocker.customer_vat_id_missing":
    "die USt-IdNr. bzw. UID des Kunden für die innergemeinschaftliche Lieferung",
  "blocker.fix.bank_account": "{currency}-Konto erfassen",
  "blocker.fix.company": "Steuerangaben ergänzen",
  "blocker.fix.customer": "Kunde ergänzen",
  "documents.subject": "Betreff",
  "documents.subjectHint": "z. B. «Website-Relaunch, Phase 2»",
  "documents.reference": "Referenz",
  "documents.referenceHint": "z. B. Bestellnummer des Kunden",
  "documents.referenceHintXRechnung": "Bestellnummer o. ä. – nötig für die XRechnung",
  "documents.referenceHintFixed": "Für die XRechnung gilt die Leitweg-ID des Kunden: {value}",
  "documents.currency": "Währung",
  "documents.language": "Sprache",
  "documents.sectionDates": "Daten",
  "documents.issueDate": "Datum",
  "documents.issueDateHint": "Vorbelegt mit heute. Leer lassen für das Datum des Ausstellens.",
  "documents.dueDate": "Fällig am",
  "documents.bankAccount": "Bankverbindung",
  "documents.bankAccountHint": "Das Konto, auf das dieses Dokument bezahlt wird.",
  "documents.bankAccountDefault": "(Standard)",
  "documents.bankAccountThirdParty": "(Drittkonto)",
  "documents.dueDateHint": "Leer lassen für die Zahlungsfrist des Kunden bzw. der Firma.",
  "documents.validUntil": "Gültig bis",
  "documents.validUntilHint": "Leer lassen für 30 Tage ab Datum.",
  "documents.serviceFrom": "Leistung von",
  "documents.serviceTo": "Leistung bis",
  "documents.serviceHint": "Maßgebend für den Steuersatz; ohne Angabe gilt das Datum.",
  "documents.servicePeriod": "Leistungszeitraum",
  "documents.dueBeforeIssue": "Das Fälligkeitsdatum liegt vor dem Datum.",
  "documents.serviceEndsBeforeStart": "Der Leistungszeitraum endet vor seinem Beginn.",
  "documents.introText": "Einleitungstext",
  "documents.closingText": "Schlusstext",
  "documents.closingTextHint": "z. B. Dank, Zahlungshinweise oder Gültigkeit des Angebots.",

  "documents.sectionLines": "Positionen",
  "documents.priceMode": "Preise",
  "documents.priceModeNet": "Netto (zzgl. {tax})",
  "documents.priceModeGross": "Brutto (inkl. {tax})",
  "documents.lineLabel": "Position {number}",
  "documents.lineError": "Position {number}: {message}",
  "documents.lineDescription": "Bezeichnung",
  "documents.lineText": "Text",
  "documents.lineTextPlaceholder": "Zwischentitel oder Hinweis",
  "documents.lineDetails": "Zusatztext zu Position {number}",
  "documents.lineDetailsPlaceholder": "Zusatztext (erscheint unter der Bezeichnung)",
  "documents.addDetails": "Zusatztext hinzufügen",
  "documents.lineQuantity": "Menge",
  "documents.lineUnit": "Einheit",
  "documents.linePrice": "Preis",
  "documents.lineDiscount": "Rabatt %",
  "documents.lineDiscountApplied": "abzüglich {percent} Rabatt",
  "documents.lineTax": "Steuersatz",
  "documents.lineSupply": "Ware oder Dienstleistung",
  "documents.goodsTreatment": "Auf diesem Dokument: {treatment}",
  "documents.intraCommunityHint":
    "Die Waren sind eine steuerfreie innergemeinschaftliche Lieferung. Bewahren Sie den Nachweis auf, dass sie im anderen EU-Land angekommen sind (z. B. Gelangensbestätigung oder Versendungsnachweis), und melden Sie die Lieferung in der Zusammenfassenden Meldung.",
  "documents.goodsExportHint":
    "Die Waren sind eine steuerfreie Ausfuhrlieferung. Steuerfrei sind sie nur mit Ausfuhrnachweis (Zolldokument); bewahren Sie ihn auf.",
  "documents.lineTaxRate": "{tax}-Satz",
  "documents.lineAmount": "Betrag",
  "documents.lineActions": "Aktionen",
  "documents.addLine": "Position hinzufügen",
  "documents.addTextLine": "Textzeile hinzufügen",
  "documents.moveUp": "Position {number} nach oben",
  "documents.moveDown": "Position {number} nach unten",
  "documents.removeLine": "Position {number} entfernen",
  "documents.tooManyLines": "Ein Dokument hat höchstens {max} Positionen.",

  "documents.sectionConditions": "Rabatt und Steuer",
  "documents.discountKind": "Gesamtrabatt",
  "documents.discountPercent": "in Prozent",
  "documents.discountAmount": "als Betrag in {currency}",
  "documents.discountValuePercent": "Rabatt in %",
  "documents.discountValueAmount": "Rabatt in {currency}",
  "documents.treatment": "Steuerfall",
  "documents.treatmentHint":
    "Wird aus Firmen- und Kundenland bestimmt. Eine manuelle Wahl wird protokolliert.",
  "documents.treatmentAuto": "Automatisch",
  "documents.treatmentAutoWith": "Automatisch: {treatment}",
  "documents.overrideReason": "Begründung",
  "documents.overrideReasonHint":
    "Warum weicht der Steuerfall ab? Wird in der Historie gespeichert.",
  "documents.overrideReasonRequired": "Bitte begründen Sie die manuelle Wahl.",

  "documents.totals": "Summen",
  "documents.totalsPending": "Die Summen erscheinen, sobald alle Angaben gültig sind.",
  "documents.subtotal": "Zwischensumme",
  "documents.documentDiscount": "Rabatt",
  "documents.net": "Netto",
  "documents.taxGroup": "{tax} {rate} auf {amount}",
  "documents.rounding": "Rundung",
  "documents.total": "Total",
  "documents.paid": "Bezahlt",
  "documents.openAmount": "Offen",

  "documents.issue": "Ausstellen",
  "documents.issueTitle": "Rechnung ausstellen?",
  "documents.issueDescription":
    "Die Rechnung erhält ihre endgültige Nummer und kann danach nicht mehr geändert werden. Korrekturen sind nur noch per Stornorechnung möglich.",
  "documents.send": "Als versendet markieren",
  "documents.sendTitle": "Angebot als versendet markieren?",
  "documents.sendDescription":
    "Das Angebot erhält seine Nummer und kann danach nicht mehr geändert werden. Änderungen erfordern ein neues Angebot (Duplizieren).",
  "documents.issuedToast": "Rechnung {number} ausgestellt.",
  "documents.sentToast": "Angebot {number} als versendet markiert.",
  "documents.draftSaved": "Entwurf gespeichert.",
  "documents.leaveConfirm": "Es gibt ungespeicherte Änderungen. Seite trotzdem verlassen?",
  "documents.moreActions": "Weitere Aktionen",
  "documents.duplicate": "Duplizieren",
  "documents.duplicatedToast": "Kopie als Entwurf erstellt.",
  "documents.convert": "In Rechnung umwandeln",
  "documents.convertedToast": "Rechnungsentwurf aus dem Angebot erstellt.",
  "documents.accept": "Angenommen",
  "documents.acceptedToast": "Angebot als angenommen markiert.",
  "documents.decline": "Abgelehnt",
  "documents.declinedToast": "Angebot als abgelehnt markiert.",
  "documents.cancel": "Stornieren",
  "documents.cancelTitle": "Rechnung stornieren?",
  "documents.cancelDescription":
    "Es wird eine Stornorechnung mit eigener Nummer ausgestellt, die diese Rechnung aufhebt. Das lässt sich nicht rückgängig machen.",
  "documents.cancelledToast": "Rechnung storniert, Stornorechnung ausgestellt.",
  "documents.deleteDraft": "Entwurf löschen",
  "documents.deleteTitle": "Entwurf löschen?",
  "documents.deleteDescription":
    "Der Entwurf wird endgültig gelöscht. Ausgestellte Dokumente bleiben immer erhalten.",
  "documents.deletedToast": "Entwurf gelöscht.",
  "documents.openCancellation": "Stornorechnung öffnen",
  "documents.openCancelledInvoice": "Stornierte Rechnung öffnen",
  "documents.openSource": "Ursprungsdokument öffnen",
  "documents.openInvoice": "Rechnungsentwurf öffnen",
  "documents.openConvertedInvoice": "Rechnung öffnen",
  "documents.history": "Verlauf",

  "documents.customerVatMissing":
    "Der Kunde ist ein Unternehmen in der EU, hat aber keine UID / USt-IdNr. Damit gälte: {withNumber}; ohne: {treatment}.",
  "documents.addCustomerVat": "UID / USt-IdNr. beim Kunden erfassen",
  "documents.markPaid": "Als bezahlt markieren",
  "documents.markedPaid": "Als bezahlt markiert.",
  "documents.addPayment": "Zahlung erfassen",
  "documents.addPaymentDescription":
    "Offener Betrag: {amount}. Für eine Teilzahlung den Betrag anpassen.",
  "documents.paidOn": "Zahlungsdatum",
  "documents.paymentAmount": "Betrag in {currency}",
  "documents.paymentNote": "Notiz",
  "documents.recordPayment": "Zahlung speichern",
  "documents.paymentTooHigh": "Der Betrag ist höher als der offene Betrag von {amount}.",
  "documents.paymentAdded": "Zahlung über {amount} erfasst.",
  "documents.paymentRemoved": "Zahlung entfernt.",
  "documents.payments": "Zahlungen",
  "documents.removePayment": "Zahlung über {amount} vom {date} entfernen",

  "writeOff.action": "Abschreiben …",
  "writeOff.title": "Rechnung {number} abschreiben",
  "writeOff.description":
    "Die Rechnung bleibt unverändert und der Kunde erhält nichts. Sie gilt nicht mehr als offen und wird nicht mehr gemahnt. Zahlt der Kunde später doch, erfassen Sie die Zahlung wie gewohnt.",
  "writeOff.openAmount": "Offener Betrag",
  "writeOff.date": "Abgeschrieben per",
  "writeOff.today": "Heute",
  "writeOff.endOfInvoiceYear": "Ende Rechnungsjahr",
  "writeOff.dateRange": "Das Datum liegt zwischen dem Rechnungsdatum und heute.",
  "writeOff.reason": "Grund",
  "writeOff.reason.gone": "Firma gelöscht oder Konkurs",
  "writeOff.reason.time_barred": "Verjährt",
  "writeOff.reason.small_amount": "Kleinbetrag",
  "writeOff.reason.untraceable": "Nicht auffindbar",
  "writeOff.reason.other": "Anderer Grund",
  "writeOff.note": "Notiz",
  "writeOff.submit": "Abschreiben",
  "writeOff.done": "Rechnung abgeschrieben.",
  "writeOff.remove": "Abschreibung zurücknehmen",
  "writeOff.removeTitle": "Abschreibung zurücknehmen?",
  "writeOff.removeDescription":
    "Der abgeschriebene Betrag ist danach wieder offen und kann gemahnt werden. Das wird im Verlauf festgehalten.",
  "writeOff.removed": "Abschreibung zurückgenommen.",
  "writeOff.card": "Abschreibung",
  "writeOff.amount": "Abgeschrieben",
  "writeOff.writtenOffOn": "Per",
  "writeOff.taxIncluded": "Darin enthaltene {tax}",
  "writeOff.recovered": "Später bezahlt",
  "writeOff.remaining": "Verlust",
  "writeOff.afterWriteOff": "Nach der Abschreibung eingegangen",
  "writeOff.paymentDescription":
    "Abgeschrieben: {amount}. Die Zahlung nimmt den Verlust in dieser Höhe zurück.",
  "badDebts.description":
    "Abschreibungen zählen im Jahr ihres Datums, spätere Zahlungen im Jahr ihres Eingangs.",
  "badDebts.year": "Jahr",
  "badDebts.writtenOff": "Abgeschrieben",
  "badDebts.recovered": "Später bezahlt",
  "badDebts.loss": "Verlust",
  "badDebts.net": "Netto",
  "settings.tabBackup": "Backup",
  "backup.title": "Backup",
  "backup.description":
    "Die Datenbank wird verschlüsselt gesichert: täglich und kurz nach jedem Ausstellen oder Stornieren.",
  "backup.stateTitle": "Stand",
  "backup.state.current": "Aktuell",
  "backup.state.stale": "Veraltet",
  "backup.state.not_set_up": "Nicht eingerichtet",
  "backup.notSetUp":
    "Backups sind nicht eingerichtet. Geht der Server kaputt, sind alle Rechnungen verloren.",
  "backup.setUpHint":
    "Das Backup-Ziel (z. B. Dropbox, Google Drive, S3 oder ein NAS) wird bei der Installation in der Datei .env festgelegt.",
  "backup.guide": "Anleitung öffnen",
  "backup.never": "Noch kein erfolgreiches Backup.",
  "backup.lastSuccess": "Letztes erfolgreiches Backup {when}.",
  "backup.lastFailure": "Letzter Versuch fehlgeschlagen: {message}",
  "backup.show": "Backups ansehen",
  "backup.check": "Backup prüfen",
  "backup.now": "Jetzt sichern",
  "backup.requested": "Backup angefordert.",
  "backup.pending": "Angefordert, startet in Kürze.",
  "backup.running": "Backup läuft …",
  "backup.unknown": "Der Stand der Backups lässt sich gerade nicht abrufen.",
  "backup.runs": "Letzte Backups",
  "backup.startedAt": "Zeitpunkt",
  "backup.reasonTitle": "Anlass",
  "backup.result": "Ergebnis",
  "backup.added": "Neu gesichert",
  "backup.reason.daily": "Täglich",
  "backup.reason.document": "Nach Ausstellen oder Storno",
  "backup.reason.manual": "Von Hand",
  "backup.status.running": "Läuft …",
  "backup.status.succeeded": "Erfolgreich",
  "backup.status.failed": "Fehlgeschlagen",
  "backup.status.not_configured": "Nicht eingerichtet",
  "backup.retention":
    "Aufbewahrt werden 7 tägliche, 4 wöchentliche, 12 monatliche und alle jährlichen Backups. Wiederherstellen ist in der Anleitung beschrieben.",
  "error.backup_not_set_up": "Backups sind nicht eingerichtet.",
  "error.backup_folder_unusable": "Dieser Ordner lässt sich nicht verwenden.",
  "error.backup_by_container":
    "Backups werden hier im Backup-Container eingerichtet (siehe Anleitung).",
  "backup.folder": "Die Backups gehen nach {folder}.",
  "backup.changeFolder": "Ordner ändern",
  "backup.firstBackup":
    "Das erste Backup startet in Kürze, sobald die Firmendaten eingerichtet sind (Einstellungen → Firma). Danach können Sie hier jederzeit sichern.",
  "backup.folderUnusable": "Dieser Ordner lässt sich nicht verwenden: {reason}",
  "backup.setup.title": "Backup einrichten",
  "backup.setup.changeTitle": "Anderen Ordner wählen",
  "backup.setup.description":
    "Am besten in einen Ordner, den ein Cloud-Dienst abgleicht. Dann liegt eine Kopie außerhalb dieses Computers.",
  "backup.setup.folders": "Ordner für die Backups",
  "backup.setup.found": "gefunden",
  "backup.setup.other": "Anderer Ordner …",
  "backup.setup.otherHint": "Zum Beispiel ein Netzlaufwerk oder eine USB-Festplatte.",
  "backup.setup.path": "Pfad des Ordners",
  "backup.setup.pathHint":
    "Der vollständige Pfad, z. B. E:\\Rhinvoice-Backup oder /Volumes/Backup/Rhinvoice. Fehlt der Ordner, wird er angelegt.",
  "backup.setup.pathMissing": "Bitte geben Sie den Pfad eines Ordners an.",
  "backup.setup.continue": "Weiter zum Schlüssel",
  "backup.setup.change": "Ordner übernehmen",
  "backup.setup.changed": "Die nächsten Backups gehen in den neuen Ordner.",
  "backup.key.title": "Ihr Wiederherstellungs-Schlüssel",
  "backup.key.description":
    "Er verschlüsselt die Backups. Ohne ihn lässt sich kein Backup wiederherstellen. Bewahren Sie ihn getrennt von diesem Computer auf, im Passwort-Manager oder ausgedruckt.",
  "backup.key.label": "Wiederherstellungs-Schlüssel",
  "backup.key.kept": "Ich habe den Schlüssel sicher aufbewahrt.",
  "backup.key.finish": "Backup einrichten",
  "backup.key.done": "Backup eingerichtet. Das erste startet in Kürze.",
  "backup.key.show": "Schlüssel anzeigen",
  "backup.key.hide": "Schlüssel ausblenden",
  "import.title.customers": "Kunden importieren",
  "import.title.articles": "Artikel importieren",
  "import.description":
    "Datei wählen, Zuordnung prüfen, Ergebnis ansehen. Erst «Importieren» speichert.",
  "import.chooseFile": "Datei wählen",
  "import.otherFile": "Andere Datei",
  "import.resultRows": "Zeilen der Datei",
  "import.missingColumns": "Spalten zuordnen: Es fehlt eine Spalte für {columns}.",
  "import.or": " oder ",
  "import.unnamedColumn": "Spalte {number}",
  "import.deleteTemplateTitle": "Vorlage löschen?",
  "import.deleteTemplateDescription":
    "Die Vorlage «{name}» wird gelöscht. Importierte Daten bleiben erhalten.",
  "import.problem.unknown_country_prefix": "unbekanntes Länderkürzel vor der PLZ",
  "import.open": "Importieren",
  "import.run.customers": {
    zero: "Keine Kunden zu importieren",
    one: "1 Kunde importieren",
    other: "{count} Kunden importieren",
  },
  "import.run.articles": {
    zero: "Keine Artikel zu importieren",
    one: "1 Artikel importieren",
    other: "{count} Artikel importieren",
  },
  "import.done.customers": {
    zero: "Keine Kunden importiert.",
    one: "1 Kunde importiert.",
    other: "{count} Kunden importiert.",
  },
  "import.done.articles": {
    zero: "Keine Artikel importiert.",
    one: "1 Artikel importiert.",
    other: "{count} Artikel importiert.",
  },
  "import.choose.customers": "CSV- oder Excel-Datei mit Kunden",
  "import.choose.articles": "CSV- oder Excel-Datei mit Artikeln",
  "import.formats":
    "CSV (UTF-8 oder Windows-1252), Excel .xlsx und .xls, höchstens 5 MB und {rows} Zeilen.",
  "import.rows": { zero: "keine Zeilen", one: "1 Zeile", other: "{count} Zeilen" },
  "import.settings": "Einstellungen",
  "import.template": "Vorlage",
  "import.templateHint":
    "Eine gespeicherte Zuordnung der Spalten, z. B. für ein früheres Programm.",
  "import.templateAuto": "Automatisch erkannt",
  "import.saveTemplate": "Als Vorlage speichern",
  "import.saveTemplateHint":
    "Die Zuordnung wird unter diesem Namen gespeichert und passt auf Dateien mit denselben Spaltennamen.",
  "import.templateName": "Name der Vorlage",
  "import.templateSaved": "Vorlage gespeichert.",
  "import.templateDeleted": "Vorlage gelöscht.",
  "import.deleteTemplate": "Vorlage «{name}» löschen",
  "import.duplicates": "Wenn es den Eintrag schon gibt",
  "import.duplicates.skip": "Überspringen",
  "import.duplicates.update": "Aktualisieren",
  "import.duplicates.create": "Neu anlegen",
  "import.duplicatesHint.customers":
    "Gleich heißt: gleiche Kundennummer, ohne Nummer gleicher Name und gleiche PLZ. Beim Aktualisieren bleiben leere Zellen ohne Wirkung.",
  "import.duplicatesHint.articles":
    "Gleich heißt: gleiche Artikelnummer, ohne Nummer gleiche Bezeichnung. Beim Aktualisieren bleiben leere Zellen ohne Wirkung.",
  "import.mapping": "Spalten zuordnen ({mapped} von {total} zugeordnet)",
  "import.required.customers":
    "Nötig ist eine Spalte für die Kundennummer oder den Namen (Firma oder Nachname). Neue Kunden brauchen außerdem PLZ und Ort.",
  "import.required.articles":
    "Nötig ist eine Spalte für die Artikelnummer oder die Bezeichnung. Neue Artikel brauchen eine Bezeichnung.",
  "import.mappingCaption": "Zuordnung der Spalten",
  "import.column": "Spalte in der Datei",
  "import.example": "Beispiel",
  "import.becomes": "Wird zu",
  "import.fieldFor": "Feld für die Spalte {column}",
  "import.skipColumn": "Nicht importieren",
  "import.field.number": "Nummer",
  "import.field.company_name": "Firmenname",
  "import.field.salutation": "Anrede",
  "import.field.first_name": "Vorname",
  "import.field.last_name": "Nachname",
  "import.field.contact_person": "Kontaktperson",
  "import.field.street": "Straße (mit Hausnummer)",
  "import.field.house_number": "Hausnummer",
  "import.field.supplement": "Adresszusatz",
  "import.field.postal_code": "PLZ",
  "import.field.city": "Ort",
  "import.field.postal_city": "PLZ und Ort",
  "import.field.country": "Land",
  "import.field.email": "E-Mail",
  "import.field.phone": "Telefon",
  "import.field.vat_number": "UID / USt-IdNr.",
  "import.field.buyer_reference": "Leitweg-ID / Käuferreferenz",
  "import.field.group": "Gruppe",
  "import.field.default_currency": "Währung",
  "import.field.default_language": "Sprache",
  "import.field.default_discount": "Rabatt in %",
  "import.field.payment_terms_days": "Zahlungsfrist in Tagen",
  "import.field.tax_exempt": "Steuerbefreit",
  "import.field.customer_since": "Kunde seit",
  "import.field.note": "Notiz",
  "import.field.name": "Bezeichnung",
  "import.field.description": "Beschreibung",
  "import.field.unit": "Einheit",
  "import.field.price": "Preis (Firmenwährung)",
  "import.field.price_chf": "Preis CHF",
  "import.field.price_eur": "Preis EUR",
  "import.field.tax_category": "Steuersatz",
  "import.field.supply": "Ware/Dienstleistung",
  "import.result": "Ergebnis des Testlaufs",
  "import.summary":
    "{new} neu · {updated} aktualisiert · {skipped} übersprungen · {error} mit Fehlern",
  "import.filter.label": "Zeilen anzeigen",
  "import.filter.all": "Alle",
  "import.status.new": "Neu",
  "import.status.updated": "Aktualisiert",
  "import.status.skipped": "Übersprungen",
  "import.status.error": "Fehler",
  "import.report": "Bericht herunterladen (CSV)",
  "import.reportFile.customers": "import-kunden.csv",
  "import.reportFile.articles": "import-artikel.csv",
  "import.noRows": "Keine Zeilen in dieser Ansicht.",
  "import.moreRows": "Die ersten {shown} von {total} Zeilen; der Bericht enthält alle.",
  "import.errorsLeftOut": "Zeilen mit Fehlern werden nicht importiert.",
  "import.row": "Zeile",
  "import.statusTitle": "Ergebnis",
  "import.number": "Nr.",
  "import.name": "Name",
  "import.detail.customers": "PLZ und Ort",
  "import.detail.articles": "Preis",
  "import.problemTitle": "Hinweis",
  "import.problemText": "{field}: {reason}",
  "import.problemValue": "{field} «{value}»: {reason}",
  "import.problem.required": "fehlt",
  "import.problem.invalid": "ungültig",
  "import.problem.invalid_amount": "kein Betrag",
  "import.problem.invalid_number": "keine ganze Zahl",
  "import.problem.invalid_date": "kein Datum",
  "import.problem.invalid_flag": "weder ja noch nein",
  "import.problem.unknown_unit": "unbekannte Einheit",
  "import.problem.unknown_tax_rate": "unbekannter Steuersatz",
  "import.problem.unknown_supply": "weder Ware noch Dienstleistung",
  "import.problem.unknown_language":
    "Sprache nicht unterstützt (Deutsch, Englisch, Französisch oder Italienisch)",
  "import.problem.unknown_currency": "Währung nicht unterstützt (CHF oder EUR)",
  "import.doneTitle": "Import abgeschlossen",
  "import.show.customers": "Zu den Kunden",
  "import.show.articles": "Zu den Artikeln",
  "import.again": "Weitere Datei importieren",
  "import.title.invoices": "Alte Rechnungen übernehmen",
  "import.demo.title": "Der Import ist in der Demo ausgeschaltet",
  "import.demo.text":
    "Alle Besucher teilen sich diese Demo, deshalb nimmt sie keine Dateien an. Installieren Sie Rhinvoice auf Ihrem eigenen Rechner oder Server – mit Docker dauert das wenige Minuten. Dort übernehmen Sie Kunden, Artikel und alte Rechnungen mit ihren PDFs.",
  "import.demo.install": "Installationsanleitung",
  "import.demo.guide": "So funktioniert der Import",
  "import.descriptionInvoices":
    "Rechnungen eines früheren Programms mit ihren Original-PDFs. Sie bleiben, wie sie waren: gesperrt, mit Nummer, Betrag und PDF.",
  "import.run.invoices": {
    zero: "Keine Rechnungen zu übernehmen",
    one: "1 Rechnung übernehmen",
    other: "{count} Rechnungen übernehmen",
  },
  "import.done.invoices": {
    zero: "Keine Rechnungen übernommen.",
    one: "1 Rechnung übernommen.",
    other: "{count} Rechnungen übernommen.",
  },
  "import.choose.invoices": "Liste der Rechnungen (CSV oder Excel)",
  "import.required.invoices":
    "Nötig sind Rechnungsnummer, Datum, Betrag und Kundennummer oder Kundenname. Die Spalte mit den Nummern erkennt Rhinvoice an den PDF-Dateien.",
  "import.reportFile.invoices": "import-rechnungen.csv",
  "import.detail.invoices": "Betrag",
  "import.show.invoices": "Zu den Rechnungen",
  "import.skippedInvoices":
    "Rechnungen, deren Nummer es schon gibt, werden übersprungen: Eine ausgestellte Rechnung ändert sich nie.",
  "import.customer": "Kunde",
  "import.pdf": "PDF",
  "import.noPdf": "kein PDF",
  "import.attachments": { zero: "keine Anhänge", one: "+ 1 Anhang", other: "+ {count} Anhänge" },
  "import.newCustomer": "Kunde neu angelegt (archiviert)",
  "import.pdfs.title": "PDF-Dateien",
  "import.pdfs.description":
    "Den Ordner mit den Rechnungen wählen (mit Unterordnern) oder einzelne PDF- und ZIP-Dateien. Rhinvoice sucht die Rechnungsnummer im Dateinamen; weitere Dateien derselben Nummer (Mahnungen, Kopien) kommen als Anhang dazu.",
  "import.pdfs.none": "Noch keine PDF-Dateien gewählt; die Rechnungen kommen dann ohne PDF.",
  "import.pdfs.chosen": {
    zero: "Keine PDF-Dateien im gewählten Ordner",
    one: "1 PDF-Datei · {size}",
    other: "{count} PDF-Dateien · {size}",
  },
  "import.pdfs.folder": "Ordner wählen",
  "import.pdfs.files": "Dateien wählen",
  "import.pdfs.clear": "PDF-Dateien entfernen",
  "import.pdfs.tooMany":
    "Mehr als {max} Dateien: Bitte den Ordner als ZIP-Datei packen und diese wählen.",
  "import.pdfs.tooLarge": "Zusammen größer als 200 MB: Bitte in mehreren Teilen übernehmen.",
  "import.unused": {
    zero: "Alle Dateien gehören zu einer Rechnung",
    one: "1 Datei gehört zu keiner Rechnung der Liste",
    other: "{count} Dateien gehören zu keiner Rechnung der Liste",
  },
  "import.unusedHint":
    "Fehlt eine Rechnung in der Liste, oder steht ihre Nummer nicht im Dateinamen? Ein PDF lässt sich später auch auf der Rechnung selbst hinzufügen.",
  "import.nextNumber":
    "Die nächste Rechnung, die Sie in Rhinvoice schreiben, bekommt die Nummer {number}.",
  "import.problem.non_positive_total": "Betrag ist null oder negativ",
  "import.problem.net_above_total": "Netto größer als der Gesamtbetrag",
  "import.problem.open_above_total": "offener Betrag größer als der Gesamtbetrag",
  "import.field.issue_date": "Rechnungsdatum",
  "import.field.due_date": "Fälligkeit",
  "import.field.customer_number": "Kundennummer",
  "import.field.customer_name": "Kundenname",
  "import.field.currency": "Währung",
  "import.field.net_amount": "Nettobetrag",
  "import.field.tax_amount": "Steuerbetrag",
  "import.field.total_amount": "Gesamtbetrag",
  "import.field.open_amount": "Offener Betrag",
  "import.field.subject": "Betreff",
  "import.field.total": "Gesamtbetrag",
  "import.field.net": "Nettobetrag",
  "error.unreadable_file":
    "Die Datei lässt sich nicht lesen. Ist es eine CSV-, Excel- oder ZIP-Datei?",
  "error.empty_file": "Die Datei ist leer.",
  "error.file_too_large":
    "Die Datei ist zu groß: Listen höchstens 5 MB, ein PDF höchstens 20 MB, alle PDFs zusammen höchstens 200 MB.",
  "error.not_a_pdf": "Das ist keine PDF-Datei.",
  "error.too_many_files":
    "Zu viele Dateien auf einmal. Bitte als ZIP-Datei oder in mehreren Teilen übernehmen.",
  "error.imported_without_pdf": "Zu dieser übernommenen Rechnung gibt es noch kein PDF.",
  "error.imported_document":
    "Eine übernommene Rechnung besteht aus ihrem PDF; das geht mit ihr nicht.",
  "error.not_imported": "Dateien lassen sich nur an übernommene Rechnungen anhängen.",
  "error.too_many_rows":
    "Die Datei hat zu viele Zeilen. Bitte in Dateien mit höchstens zehntausend Zeilen teilen.",
  "error.too_many_columns": "Die Datei hat mehr als 100 Spalten.",
  "error.company_not_set_up": "Bitte zuerst die Firma einrichten.",
  "error.mapping_incomplete": "Es fehlen Spalten, ohne die keine Zeile importiert werden kann.",
  "error.invalid_mapping": "Die Zuordnung der Spalten ist ungültig.",
  "error.column_used_twice": "Eine Spalte ist zwei Feldern zugeordnet.",
  "error.unknown_column": "Die Zuordnung nennt eine Spalte, die es nicht gibt.",
  "error.unknown_field": "Die Zuordnung nennt ein unbekanntes Feld.",
  "error.empty_template": "Die Vorlage ordnet keine Spalte zu.",
  "wizard.title": "Rhinvoice einrichten",
  "wizard.steps": "Schritte der Einrichtung",
  "wizard.stepCountry": "Land",
  "wizard.stepCompany": "Firma",
  "wizard.stepDone": "(erledigt)",
  "paymentCode.swiss_qr_bill": "QR-Rechnung",
  "paymentCode.epc": "GiroCode (EPC-QR)",
  "wizard.countryTitle": "Wo ist Ihre Firma?",
  "wizard.countryHint":
    "Das Land bestimmt Steuersätze, Pflichtangaben, Rundung und den Zahlungs-QR-Code auf der Rechnung.",
  "wizard.smallBusinessHint": "Rechnungen ohne Steuer, mit dem vorgeschriebenen Hinweis.",
  "wizard.later": "Später einrichten",
  "wizard.next": "Weiter",
  "wizard.back": "Zurück",
  "wizard.finish": "Speichern und weiter",
  "wizard.changeLater": "Alles lässt sich später in den Einstellungen ändern.",
  "wizard.companyTitle": "Ihre Firma",
  "wizard.companyHint": "Name und Adresse stehen als Absender auf jeder Rechnung.",
  "wizard.taxNumberHint": "Vom Finanzamt, falls keine USt-IdNr. vorhanden ist.",
  "wizard.saved": "Firma gespeichert. Die nächsten Schritte stehen in der Übersicht.",
  "onboarding.title": "Willkommen bei Rhinvoice",
  "onboarding.progress": "Einrichtung · {done} von {total} erledigt",
  "onboarding.done": "erledigt",
  "onboarding.open": "offen",
  "onboarding.dismiss": "Checkliste ausblenden",
  "onboarding.dismissed": "Checkliste ausgeblendet.",
  "onboarding.step.company": "Land und Firma",
  "onboarding.step.bank_account": "Bankkonto erfassen",
  "onboarding.step.numbering": "Nummernkreise prüfen",
  "onboarding.step.customers": "Kunden erfassen oder importieren",
  "onboarding.step.first_invoice": "Erste Rechnung schreiben",
  "onboarding.step.backup": "Backup einrichten",
  "onboarding.hint.company": "Absender, Steuersätze und Pflichtangaben der Rechnungen.",
  "onboarding.hint.bank_account": "Für den Zahlungs-QR-Code: QR-Rechnung oder GiroCode.",
  "onboarding.hint.numbering":
    "Wechsel von einem anderen Programm? Die nächste Rechnungsnummer kann dort weiterzählen.",
  "onboarding.hint.customers": "Einzeln anlegen oder aus einer CSV- oder Excel-Datei übernehmen.",
  "onboarding.hint.first_invoice": "Mit Live-Vorschau; ausgestellt wird erst auf Knopfdruck.",
  "onboarding.hint.backup": "Damit keine Rechnung verloren geht, z. B. nach Dropbox.",
  "onboarding.action.company": "Einrichten",
  "onboarding.action.bank_account": "Bankkonto erfassen",
  "onboarding.action.numbering": "Prüfen",
  "onboarding.action.import": "Importieren",
  "onboarding.action.customers": "Kunde anlegen",
  "onboarding.action.first_invoice": "Rechnung schreiben",
  "onboarding.action.backup": "Backup ansehen",
  "settings.tabPrint": "Druckvorlage",
  "printLayout.title": "Druckvorlage",
  "printLayout.description": "Wie Rechnungen, Angebote und Stornos auf Papier und im PDF aussehen.",
  "printLayout.template": "Vorlage",
  "printLayout.template.classic": "Klassisch",
  "printLayout.template.modern": "Modern",
  "printLayout.template.plain": "Schlicht",
  "printLayout.templateHint.classic": "Linie unter dem Kopf, graue Tabellenkopfzeile",
  "printLayout.templateHint.modern": "Firmenfarbe als Akzent, Total hervorgehoben",
  "printLayout.templateHint.plain": "Viel Weißraum, ohne Farbe",
  "printLayout.logoAndFont": "Logo und Schrift",
  "printLayout.logoPosition": "Logo",
  "printLayout.logoPosition.left": "Links",
  "printLayout.logoPosition.right": "Rechts",
  "printLayout.logoSize": "Größe des Logos",
  "printLayout.logoSize.small": "Klein",
  "printLayout.logoSize.medium": "Mittel",
  "printLayout.logoSize.large": "Groß",
  "printLayout.font": "Schrift",
  "printLayout.font.sans": "Ohne Serifen (Inter)",
  "printLayout.font.serif": "Mit Serifen (Source Serif)",
  "printLayout.colourHint": "Logo und Firmenfarbe werden unter Einstellungen → Firma festgelegt.",
  "printLayout.content": "Inhalt",
  "printLayout.senderLine": "Absenderzeile über der Adresse",
  "printLayout.senderLineHint": "Die kleine Zeile im Adressfenster.",
  "printLayout.contact": "Kontaktangaben im Kopf",
  "printLayout.contactHint": "Telefon, E-Mail und Website unter der Adresse oben rechts.",
  "printLayout.positionNumbers": "Positionsnummern",
  "printLayout.positionNumbersHint": "Die Spalte «Pos.» in der Tabelle.",
  "printLayout.footer": "Fußzeile",
  "printLayout.footerAccounts": "Bankverbindung",
  "printLayout.footerAccounts.all": "Alle Konten",
  "printLayout.footerAccounts.invoice_currency": "Nur Rechnungswährung",
  "printLayout.footerAccounts.none": "Keine",
  "printLayout.footerHint":
    "Konten derselben Bank stehen zusammen. Konten Dritter erscheinen nur auf Dokumenten, die an sie bezahlt werden. Der Zahlungs-QR-Code nimmt immer das Konto, an das die Rechnung bezahlt wird.",
  "printLayout.reset": "Zurücksetzen",
  "printLayout.issuedStay": "Gilt für neue PDFs. Ausgestellte Dokumente behalten ihr PDF.",
  "printLayout.preview": "Vorschau der Druckvorlage",
  "printLayout.previewHint": "Vorschau mit der neuesten Rechnung.",
  "settings.tabDunning": "Mahnwesen",
  "dunning.title": "Mahnwesen",
  "dunning.description":
    "Überfällige Rechnungen, die geschriebenen Mahnungen und der nächste Schritt.",
  "dunning.settings": "Mahnstufen einstellen",
  "dunning.emptyTitle": "Nichts überfällig",
  "dunning.emptyDescription":
    "Sobald eine Rechnung ihr Fälligkeitsdatum überschreitet, erscheint sie hier.",
  "dunning.table": "Überfällige Rechnungen",
  "dunning.invoice": "Rechnung",
  "dunning.customer": "Kunde",
  "dunning.open": "Offen",
  "dunning.overdue": "Überfällig",
  "dunning.reminders": "Geschrieben",
  "dunning.next": "Nächster Schritt",
  "dunning.days": { zero: "Seit heute", one: "Seit 1 Tag", other: "Seit {count} Tagen" },
  "dunning.none": "Noch keine",
  "dunning.level.1": "Zahlungserinnerung",
  "dunning.level.2": "1. Mahnung",
  "dunning.level.3": "2. Mahnung",
  "dunning.done":
    "Alle Stufen geschrieben. Weitere Schritte (z. B. Inkasso) außerhalb von Rhinvoice.",
  "dunning.write": "{level} schreiben",
  "dunning.written": "{level} geschrieben.",
  "dunning.openPdf": "PDF öffnen",
  "dunning.dueSince": "Fällig seit {date}",
  "dunning.dueFrom": "Fällig ab {date}",
  "dunning.confirmTitle": "{level} für {number} schreiben?",
  "dunning.confirmEarly": "Diese Stufe ist erst ab {date} fällig.",
  "dunning.confirmDetails":
    "An {customer}, neue Frist {deadline}, Mahngebühr {fee}. Die Mahnung bleibt im Verlauf der Rechnung.",
  "dunning.problems": "Bitte die markierten Felder korrigieren.",
  "dunning.problem.days": "Ganze Zahl von 0 bis 365",
  "dunning.problem.paymentDays": "Ganze Zahl von 1 bis 365",
  "dunning.problem.fee": "Betrag bis 1000 in Schritten von 0.05",
  "dunning.problem.text": "Höchstens 2000 Zeichen",
  "eInvoice.beforeEInvoices": "Das PDF wurde erstellt, bevor Rhinvoice E-Rechnungen einbettete.",
  "eInvoice.issueWarning": "Diese Rechnung wird ohne E-Rechnung ausgestellt. Es fehlt:",
  "eInvoice.issueXRechnungWarning": "Für die XRechnung (deutsche Behörden) fehlt:",
  "eInvoice.xrechnungSummary": "XRechnung für deutsche Behörden",
  "eInvoice.title": "E-Rechnung",
  "eInvoice.embedded":
    "Das PDF enthält die E-Rechnung (ZUGFeRD, EN 16931): Buchhaltungsprogramme lesen die Daten direkt.",
  "eInvoice.pending": "Die E-Rechnung wird beim Erstellen des PDF eingebettet (ZUGFeRD, EN 16931).",
  "eInvoice.notEmbedded": "Das archivierte PDF enthält keine E-Rechnung.",
  "eInvoice.disabled": "Beim Ausstellen war die E-Rechnung in der Druckvorlage ausgeschaltet.",
  "eInvoice.missing": "Für eine E-Rechnung fehlte beim Ausstellen:",
  "eInvoice.xrechnung": "XRechnung (XML)",
  "eInvoice.xrechnungHint":
    "Für deutsche Behörden; die Leitweg-ID kommt vom Kunden oder aus der Referenz der Rechnung.",
  "eInvoice.xrechnungMissing": "Für eine XRechnung fehlte beim Ausstellen:",
  "eInvoice.nextTime":
    "Ausgestellte Rechnungen bleiben unverändert. Ergänzen Sie die Angaben für künftige Rechnungen.",
  "eInvoice.problem.seller_id_missing":
    "UID, USt-IdNr. oder Handelsregistereintrag (Einstellungen → Firma)",
  "eInvoice.problem.seller_vat_id_missing": "MWST-Nummer bzw. USt-IdNr. (Einstellungen → Firma)",
  "eInvoice.problem.seller_tax_id_missing":
    "MWST-Nummer, USt-IdNr. oder Steuernummer (Einstellungen → Firma)",
  "eInvoice.problem.buyer_vat_id_missing": "UID bzw. USt-IdNr. mit Länderkürzel beim Kunden",
  "eInvoice.problem.buyer_reference_missing": "Leitweg-ID beim Kunden oder Referenz der Rechnung",
  "eInvoice.problem.seller_email_missing": "E-Mail (Einstellungen → Firma)",
  "eInvoice.problem.seller_phone_missing": "Telefon (Einstellungen → Firma)",
  "eInvoice.problem.buyer_email_missing": "E-Mail beim Kunden",
  "eInvoice.problem.bank_account_missing": "Bankkonto (Einstellungen → Bankkonten)",
  "printLayout.eInvoiceTitle": "E-Rechnung",
  "printLayout.eInvoice": "E-Rechnung im PDF (ZUGFeRD)",
  "printLayout.eInvoiceHint":
    "Ab jetzt ausgestellte Rechnungen und Stornorechnungen enthalten ihre Daten zusätzlich maschinenlesbar (EN 16931). Das PDF sieht gleich aus.",
  "error.e_invoice_incomplete": "Für eine XRechnung fehlen Angaben.",
  "error.not_an_e_invoice": "Nur ausgestellte Rechnungen und Stornorechnungen sind E-Rechnungen.",
  "documents.reminders": "Mahnungen",
  "dunning.settingsTitle": "Mahnstufen",
  "dunning.settingsDescription":
    "Drei Stufen: Zahlungserinnerung, 1. und 2. Mahnung. Jede Stufe wird nach einer Anzahl Tagen fällig und setzt eine neue Zahlungsfrist.",
  "dunning.daysAfterInvoice": "Tage nach Fälligkeit",
  "dunning.daysAfterReminder": "Tage nach Ablauf der letzten Frist",
  "dunning.paymentDays": "Neue Zahlungsfrist in Tagen",
  "dunning.fee": "Mahngebühr",
  "dunning.feeHint":
    "In der Währung der Rechnung, ohne MWST/USt. Nur mit Vereinbarung oder belegten Kosten; 0 für keine.",
  "dunning.textDe": "Text (Deutsch)",
  "dunning.textEn": "Text (Englisch)",
  "dunning.textFr": "Text (Französisch)",
  "dunning.textIt": "Text (Italienisch)",
  "dunning.textHint":
    "Platzhalter: {faellig} (neue Frist), {betrag}, {waehrung}, {nummer}, {kunde}.",
  "error.not_remindable": "Diese Rechnung ist nicht überfällig oder hat schon alle Mahnungen.",
  "error.levels_incomplete": "Es braucht alle drei Mahnstufen.",
  "recurring.short": "Wiederkehrend",
  "recurring.title": "Wiederkehrende Rechnungen",
  "recurring.description":
    "Rechnungen, die Rhinvoice jeden Monat, jedes Quartal oder jedes Jahr von selbst schreibt.",
  "recurring.new": "Neuer Plan",
  "recurring.newDescription": "Die Rechnung unten wird zu jedem Termin neu erstellt.",
  "recurring.emptyTitle": "Noch keine wiederkehrenden Rechnungen",
  "recurring.emptyDescription":
    "Für Hosting, Wartung, Abos oder Pauschalen: Legen Sie die Rechnung einmal an, Rhinvoice schreibt sie zu jedem Termin neu.",
  "recurring.name": "Bezeichnung",
  "recurring.nameHint": "Nur für Sie, z. B. «Hosting Holzwerk».",
  "recurring.customer": "Kunde",
  "recurring.interval": "Intervall",
  "recurring.intervalOption.monthly": "Monatlich",
  "recurring.intervalOption.quarterly": "Vierteljährlich",
  "recurring.intervalOption.half_yearly": "Halbjährlich",
  "recurring.intervalOption.yearly": "Jährlich",
  "recurring.nextDate": "Nächste Rechnung",
  "recurring.amount": "Betrag",
  "recurring.action": "Am Termin",
  "recurring.actionShort.draft": "Entwurf",
  "recurring.actionShort.issue": "Ausstellen",
  "recurring.actionShort.send": "Ausstellen und senden",
  "recurring.actionOption.draft": "Entwurf erstellen",
  "recurring.actionOption.issue": "Ausstellen",
  "recurring.actionOption.send": "Ausstellen und per E-Mail senden",
  "recurring.actionHint.draft":
    "Der Entwurf wartet unter Rechnungen, bis Sie ihn prüfen und ausstellen.",
  "recurring.actionHint.issue": "Die Rechnung wird mit Nummer ausgestellt; Sie senden sie selbst.",
  "recurring.actionHint.send":
    "Die Rechnung wird ausgestellt und an die E-Mail-Adresse des Kunden gesendet.",
  "recurring.state": "Status",
  "recurring.stateLabel.active": "Aktiv",
  "recurring.stateLabel.paused": "Pausiert",
  "recurring.stateLabel.finished": "Beendet",
  "recurring.stateLabel.problem": "Problem",
  "recurring.create": "Plan anlegen",
  "recurring.created": "Plan angelegt.",
  "recurring.planTitle": "Wiederholung",
  "recurring.planDescription": "Wann die Rechnung geschrieben wird und was dann geschieht.",
  "recurring.startDate": "Erste Rechnung am",
  "recurring.startDateHint":
    "Jede weitere folgt im Intervall ab diesem Tag (der 31. bleibt Monatsende).",
  "recurring.endDate": "Letzte Rechnung bis",
  "recurring.endDateHint": "Leer lassen, bis Sie den Plan beenden.",
  "recurring.onTheDay": "Am Termin",
  "recurring.mailNotConfigured": "Der E-Mail-Versand ist noch nicht eingerichtet.",
  "recurring.servicePeriod": "Leistungszeitraum eintragen (z. B. 01.10.–31.10.)",
  "recurring.moreHint": "Betreff, Referenz, Währung, Sprache, Rabatt",
  "recurring.field.name": "Bezeichnung",
  "recurring.field.startDate": "Erste Rechnung am",
  "recurring.field.endDate": "Letzte Rechnung bis",
  "recurring.problem.required": "Bitte ausfüllen.",
  "recurring.problem.endBeforeStart": "Das Ende liegt vor der ersten Rechnung.",
  "recurring.statusTitle": "Stand",
  "recurring.finished": "Der Plan ist beendet: Es folgt keine Rechnung mehr.",
  "recurring.next": "Nächste Rechnung am {date}.",
  "recurring.nextWithPeriod": "Nächste Rechnung am {date}, Leistungszeitraum bis {to}.",
  "recurring.customerArchived":
    "Der Kunde ist archiviert, der Plan verrechnet ihn aber weiter. Pausieren Sie den Plan, wenn das nicht mehr stimmt.",
  "recurring.overriddenSource":
    "Die Rechnung hatte einen von Hand gewählten Steuerfall. Wiederkehrende Rechnungen bestimmen ihn automatisch; prüfen Sie die Vorschau.",
  "recurring.pausedHint": "Pausiert: Termine während der Pause entfallen.",
  "recurring.noRuns": "Noch keine Rechnung geschrieben.",
  "recurring.runs": "Geschriebene Rechnungen",
  "recurring.outcome.draft": "Entwurf",
  "recurring.outcome.issued": "Ausgestellt",
  "recurring.outcome.sent": "Gesendet",
  "recurring.outcome.failed": "Fehlgeschlagen",
  "recurring.openInvoice": "Rechnung öffnen",
  "recurring.customerEmailMissing":
    "Nicht gesendet: Beim Kunden ist keine E-Mail-Adresse hinterlegt.",
  "recurring.interrupted": "Abgebrochen, bevor die Rechnung geschrieben war.",
  "recurring.interruptedAfterCreate":
    "Abgebrochen, nachdem die Rechnung erstellt war. Bitte prüfen Sie die Rechnung.",
  "recurring.pause": "Pausieren",
  "recurring.resume": "Fortsetzen",
  "recurring.paused": "Plan pausiert.",
  "recurring.resumed": "Plan fortgesetzt.",
  "recurring.delete": "Plan löschen",
  "recurring.deleteTitle": "Plan «{name}» löschen?",
  "recurring.deleteDescription":
    "Es werden keine weiteren Rechnungen geschrieben. Bereits geschriebene Rechnungen bleiben erhalten.",
  "recurring.deleted": "Plan «{name}» gelöscht.",
  "recurring.makeRecurring": "Wiederkehrend machen",
  "error.plan_start_in_past":
    "Die erste Rechnung darf nicht in der Vergangenheit liegen. Ein neues Intervall braucht einen neuen ersten Tag (heute oder später).",
  "error.plan_not_paused": "Der Plan ist nicht pausiert.",
  "mail.sendAction": "Per E-Mail senden",
  "mail.sendTitle": "{title} per E-Mail senden",
  "mail.sendDescription":
    "Prüfen Sie Empfänger und Text. Das PDF wird angehängt, der Versand im Verlauf vermerkt.",
  "mail.notConfigured":
    "Der E-Mail-Versand ist noch nicht eingerichtet. Hinterlegen Sie dazu einmal den Mailserver Ihres E-Mail-Anbieters.",
  "mail.setUp": "E-Mail einrichten",
  "mail.to": "An",
  "mail.toHint": "Mehrere Adressen mit Komma trennen.",
  "mail.noCustomerAddress":
    "Beim Kunden ist keine E-Mail-Adresse hinterlegt. Mehrere Adressen mit Komma trennen.",
  "mail.subject": "Betreff",
  "mail.body": "Nachricht",
  "mail.attachments": "Anhang",
  "mail.attachXrechnung": "XRechnung (XML) zusätzlich anhängen",
  "mail.copyTo": "Eine Kopie geht an {address}.",
  "mail.send": "Senden",
  "mail.checkFields": "Bitte prüfen Sie die markierten Angaben.",
  "mail.cancelledWarning":
    "Diese Rechnung ist storniert. Senden Sie sie nur, wenn der Kunde sie nochmals braucht.",
  "mail.sending": "Wird gesendet …",
  "mail.sent": "E-Mail an {to} gesendet.",
  "mail.recipientMissing": "Bitte mindestens eine E-Mail-Adresse angeben.",
  "mail.invalidRecipient": "«{address}» ist keine gültige E-Mail-Adresse.",
  "mail.tooManyRecipients": "Höchstens {max} Empfänger.",
  "mail.serverTitle": "Mailserver",
  "mail.serverDescription":
    "Rhinvoice sendet über den Postausgangsserver (SMTP) Ihres E-Mail-Anbieters. Die Angaben finden Sie in dessen Hilfe, z. B. Microsoft 365: smtp.office365.com, Port 587, STARTTLS. Gmail und iCloud verlangen ein App-Passwort.",
  "mail.problems": "Bitte prüfen Sie die markierten Angaben.",
  "mail.host": "Server",
  "mail.hostHint": "Zum Beispiel smtp.ihr-anbieter.ch",
  "mail.port": "Port",
  "mail.security": "Verschlüsselung",
  "mail.securityOption.starttls": "STARTTLS (meist Port 587)",
  "mail.securityOption.tls": "SSL/TLS (meist Port 465)",
  "mail.securityOption.none": "Keine",
  "mail.securityHint.starttls": "Empfohlen: Die Verbindung wird nach dem Aufbau verschlüsselt.",
  "mail.securityHint.tls": "Die Verbindung ist von Anfang an verschlüsselt.",
  "mail.securityHint.none": "Unverschlüsselt. Nur für einen Mailserver im eigenen Netz verwenden.",
  "mail.username": "Benutzername",
  "mail.usernameHint":
    "Meist die E-Mail-Adresse. Leer lassen, wenn der Server keine Anmeldung verlangt.",
  "mail.password": "Passwort",
  "mail.passwordHint": "Wird gespeichert und nie mehr angezeigt.",
  "mail.passwordKept": "Ein Passwort ist gespeichert. Leer lassen, um es zu behalten.",
  "mail.sender": "Absenderadresse",
  "mail.senderHint": "Viele Anbieter senden nur von eigenen Adressen.",
  "mail.senderName": "Absendername",
  "mail.replyTo": "Antwortadresse",
  "mail.replyToHint": "Antworten der Kunden gehen an diese Adresse statt an den Absender.",
  "mail.copyToSender": "Jede E-Mail als Kopie an die Absenderadresse senden",
  "mail.problem.required": "Bitte ausfüllen.",
  "mail.problem.port": "Eine Zahl zwischen 1 und 65535.",
  "mail.problem.email": "Keine gültige E-Mail-Adresse.",
  "mail.problem.passwordWithoutUser": "Ein Passwort braucht einen Benutzernamen.",
  "mail.testTitle": "Test-E-Mail",
  "mail.testDescription": "Prüfen Sie die gespeicherten Angaben mit einer kurzen E-Mail.",
  "mail.testFirstSave": "Speichern Sie zuerst den Mailserver.",
  "mail.testTo": "Senden an",
  "mail.sendTest": "Test-E-Mail senden",
  "mail.testSent": "Test-E-Mail an {to} gesendet. Bitte prüfen Sie den Posteingang.",
  "mail.templatesTitle": "E-Mail-Vorlagen",
  "mail.templatesDescription":
    "Betreff und Text der E-Mails, mit denen Dokumente und Mahnungen versendet werden. Platzhalter werden beim Versand ausgefüllt.",
  "mail.templateKind": "Für",
  "mail.templateLanguage": "Sprache",
  "mail.templateOwn": "Eigene Vorlage.",
  "mail.templateBuiltIn": "Mitgelieferte Vorlage.",
  "mail.restoreTemplate": "Mitgelieferte Vorlage verwenden",
  "mail.templateRestored": "Mitgelieferte Vorlage wiederhergestellt.",
  "mail.kind.invoice": "Rechnung",
  "mail.kind.quote": "Angebot",
  "mail.kind.cancellation": "Stornorechnung",
  "mail.kind.reminder_1": "Zahlungserinnerung",
  "mail.kind.reminder_2": "1. Mahnung",
  "mail.kind.reminder_3": "2. Mahnung",
  "mail.reminderSent": "{level} per E-Mail gesendet",

  "export.open": "Exportieren",
  "export.title": "Rechnungen exportieren",
  "export.description":
    "Die ausgestellten Rechnungen und Stornorechnungen eines Zeitraums nach Rechnungsdatum, für die Buchhaltung oder die Steuerberatung.",
  "export.period": "Zeitraum",
  "export.period.month": "Monat",
  "export.period.quarter": "Quartal",
  "export.period.year": "Jahr",
  "export.period.custom": "Frei",
  "export.month": "Monat",
  "export.quarter": "Quartal",
  "export.quarterName": "{quarter}. Quartal",
  "export.year": "Jahr",
  "export.from": "Von",
  "export.to": "Bis",
  "export.problem.missing": "Bitte beide Tage angeben.",
  "export.problem.reversed": "Das Ende liegt vor dem Anfang.",
  "export.problem.tooLong": "Höchstens zehn Jahre auf einmal.",
  "export.format": "Format",
  "export.format.xlsx": "Excel",
  "export.format.csv": "CSV",
  "export.format.pdf": "PDF",
  "export.withPdfs": "Rechnungs-PDFs als ZIP beilegen",
  "export.withPdfsHint":
    "Eine ZIP-Datei mit der Liste und dem PDF jeder Rechnung; die Spalte «Datei» nennt seinen Namen.",
  "export.download": "Herunterladen",
  "export.preparing": "Wird erstellt …",
  "error.period_reversed": "Das Ende des Zeitraums liegt vor dem Anfang.",
  "error.period_too_long": "Ein Zeitraum umfasst höchstens zehn Jahre.",
  "error.export_busy": "Ein anderer Export wird gerade erstellt. Bitte gleich nochmals versuchen.",
} as const;

export type MessageKey = keyof typeof de;
